<template>
  <div id="mobile" @mousedown="playAudio">
    <!--顶部浮层-->
    <transition name="moveIn">
      <div class="top-cover" v-show="interfaceShow"></div>
    </transition>

    <!--底部浮层-->
    <transition name="moveIn">
      <div class="bottom-cover" v-show="interfaceShow"></div>
    </transition>

    <!--小地图区域-->
    <transition name="moveIn">
      <div class="map-box" v-show="interfaceShow && showRightList">
        <img ref="radar" class="map-circle" src="../assets/img/pc/map-circle-background.png" alt="">
      </div>
    </transition>

    <!--右侧浮层-->
    <transition name="opacity">
      <div class="right-cover" :class="{'show': showRightList}" v-show="interfaceShow && interfaceShowaddr">
        <div class="list-box">
          <span class="sanjiao"></span>
          <div class="list-area">
            <h2>
              <span class="curradrr">当前位置：{{entityNameList[entityNameIndex]}}</span>
            </h2>
            <div class="list-map-box">
              <div class="list-marker-box">
                <div class="marker-btn" :class="{'selected': entityNameIndex === index, 'jump': entityNameHoverIndex === index}" v-for="(mk, index) in appInfo.map.marker" :key="index" :style="{'left': mk.left + '%', 'top': mk.top + '%'}" @click="tempSetPano(index)" @mouseover="listMouseOver(index)" @mouseout="listMouseOut(index)">
                  <i class="num">{{index + 1}}</i>
                </div>
              </div>
            </div>
            <div class="list">
              <ul>
                <li :class="{'selected': entityNameIndex === index}" v-for="(name, index) in entityNameList" :key="index" @click="tempSetPano(index)" @mouseover="listMouseOver(index)" @mouseout="listMouseOut(index)">
                  <p class="omitline1">{{index + 1}}.{{name}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="button" @click="showRightList = !showRightList"></div>
        </div>
      </div>
    </transition>

    <!--logo部分  曲沃部分改为导航栏-->
    <transition name="moveIn">
      <div class="logo-box" v-show="interfaceShow">
        <div class="clearfix">
          <div class="logo"></div>

          <div class="addr" >
            <span @click="changedh" :class="{addhover:interfaceShowaddr}"></span>
          </div>

          <div class="daolan tuijian">
            <div class="daolan_bigBtn" @click="switchPanoRoamMarkerHideType(true)" >
              <span :class="{active: recommend}">推荐路线</span>
              <!--<img class="acive" v-if="!isRoaming" src="../assets/img/pc/handOnicon.png" alt="">-->
              <!--<img class="acive" v-else src="../assets/img/pc/handOffIcon.png" alt="">-->
            </div>
          </div>
          <div class="daolan">
            <div class="daolan_bigBtn" :class="{'pause': isRoaming}">
              <span :class="{active:!isRoaming && !recommend}" @click="autonomy()">自主参观</span>
              <span  :class="{active:isRoaming && !recommend}"  @click="todoRoaming()">智能导览</span>
              <!--<img class="acive" v-if="!isRoaming" src="../assets/img/pc/handOnicon.png" alt="">-->
              <!--<img class="acive" v-else src="../assets/img/pc/handOffIcon.png" alt="">-->
            </div>
          </div>

          <div class="littleicon">
              <span class="music" :class="{'musicActive': mainAudioPlay}" @click="bgMusicControl()"></span>
              <span class="share" :class="{'shareActive': isShowShare}" @click="setShowShare()"></span>
              <span class="full" :class="{'fangdaActive': isPageFullScreen}"  @click="setPageFullscreen()"></span>
          </div>

          <transition name="opacity">
            <div class="share-box" v-show="interfaceShow && isShowShare">
              <span class="sanjiao"></span>
              <div class="share-btn-box clearfix" @click.stop="">
                <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wx'}" @click.stop="shareTo('wx')">
                  <div class="wx"></div>
                  <p>微信</p>
                </div>
                <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'qq'}" @click.stop="shareTo('qq')">
                  <div class="qq"></div>
                  <p>QQ</p>
                </div>
                <div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wb'}" @click.stop="shareTo('wb')">
                  <div class="wb"></div>
                  <p>微博</p>
                </div>
              </div>
              <div class="qrcode-box" v-show="whichShareBtnSelect === 'wx'">
                <!--<p class="share-wx">分享到微信</p>-->
                <div class="qrcode">
                  <canvas id="canvas"></canvas>
                </div>
                <p class="share-tip">用微信“扫一扫”二维码，即可把链接<br>分享给您的微信好友或朋友圈</p>
              </div>
            </div>
          </transition>

          <!--<span v-if="visitNum > 0"></span>-->
          <!--<p class="visit-num" v-if="visitNum > 0">{{visitNum}}</p>-->
        </div>
      </div>
    </transition>
    <!--<transition name="moveIn">-->
      <!--<div class="daolan" v-show="interfaceShow">-->
          <!--<div class="daolan_bigBtn" :class="{'pause': isRoaming}" @click="todoRoaming()">-->
              <!--<img class="acive" v-if="!isRoaming" src="../assets/img/pc/handOnicon.png" alt="">-->
              <!--<img class="acive" v-else src="../assets/img/pc/handOffIcon.png" alt="">-->
            <!--</div>-->
        <!--</div>-->
    <!--</transition>-->

    <!--<transition name="moveIn">-->
      <!--<div class=" btns_left_box" v-show="interfaceShow">-->
        <!--<div class="btn_full" @click="setPageFullscreen()">-->
        <!--</div>-->

        <!--<div class="btn_share" :class="{'selected': isShowShare}" @click="setShowShare()">-->
           <!--<transition name="opacity">-->
              <!--<div class="share-box" v-show="interfaceShow && isShowShare">-->
                <!--<div class="share-btn-box clearfix" @click.stop="">-->
                  <!--<div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wx'}" @click.stop="shareTo('wx')">-->
                    <!--<div class="wx"></div>-->
                    <!--<p>微信</p>-->
                  <!--</div>-->
                  <!--<div class="share-btn" :class="{'selected': whichShareBtnSelect === 'qq'}" @click.stop="shareTo('qq')">-->
                    <!--<div class="qq"></div>-->
                    <!--<p>QQ</p>-->
                  <!--</div>-->
                  <!--<div class="share-btn" :class="{'selected': whichShareBtnSelect === 'wb'}" @click.stop="shareTo('wb')">-->
                    <!--<div class="wb"></div>-->
                    <!--<p>微博</p>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<div class="qrcode-box" v-show="whichShareBtnSelect === 'wx'">-->
                  <!--&lt;!&ndash;<p class="share-wx">分享到微信</p>&ndash;&gt;-->
                  <!--<div class="qrcode">-->
                    <!--<canvas id="canvas"></canvas>-->
                  <!--</div>-->
                  <!--<p class="share-tip">用微信“扫一扫”二维码，即可把链接<br>分享给您的微信好友或朋友圈</p>-->
                <!--</div>-->
              <!--</div>-->
            <!--</transition>-->
        <!--</div>-->

        <!--<div class="btn_musice" :class="{'selected': mainAudioPlay}" @click="bgMusicControl()">-->
           <!--<i class="icon music"></i>-->
        <!--</div>-->
      <!--</div>-->
    <!--</transition>-->

    <!--底部音频-->
    <!--<transition name="moveIn">-->
      <!--<div class="intro-audio-box" v-if="baseInfoJson[curPano.entityId] && baseInfoJson[curPano.entityId].audioIntro">-->
        <!--<span><i></i></span>-->

        <!--<div class="play-btn" :class="{'pause': infoAudioPlay}" @click.stop="playIntroAudio('singleInfoAudio')"></div>-->
        <!--<div class="time">{{(parseInt(audioTime.playMinutes / 60) > 0 ? (parseInt(audioTime.playMinutes / 60) > 10 ? parseInt(audioTime.playMinutes / 60) : '0' + parseInt(audioTime.playMinutes / 60)) : '00') + ':' + (parseInt(audioTime.playMinutes % 60) > 0 ? (parseInt(audioTime.playMinutes % 60) > 10 ? parseInt(audioTime.playMinutes % 60) : '0' + parseInt(audioTime.playMinutes % 60)) : '00') + '/' + (parseInt(audioTime.totalMinutes / 60) > 0 ? (parseInt(audioTime.totalMinutes / 60) > 10 ? parseInt(audioTime.totalMinutes / 60) : '0' + parseInt(audioTime.totalMinutes / 60)) : '00') + ':' + (parseInt(audioTime.totalMinutes % 60) > 0 ? (parseInt(audioTime.totalMinutes % 60) > 10 ? parseInt(audioTime.totalMinutes % 60) : '0' + parseInt(audioTime.totalMinutes % 60)) : '00')}}</div>-->
        <!--<div class="progress-box">-->
          <!--<div class="progress" :style="{'width': audioTime.per}"></div>-->
        <!--</div>-->
        <!--<audio id="singleInfoAudio" :src="baseInfoJson[curPano.entityId].audioIntro" style="display: none" controls hidden="true"></audio>-->
      <!--</div>-->
    <!--</transition>-->

    <!--评论部分-->
    <!-- <transition name="moveIn">
      <comment
        ref="comment"
        v-show="interfaceShow || markerInfo.display"
        :APPID="APPID"
        :panoIntroShow="panoIntroShow"
      ></comment>
    </transition> -->

    <!---------------------------->

    <!--视频蒙层-->
    <transition name="cover">
      <div class="main-cover" id="videoBox" v-show="videoFullscreen" @click.stop="closeMediaFullscreen()">
        <div class="box">
          <div class="video-box">
            <video :src="videoUrl" :autoplay="autoplay" controls></video>
          </div>
          <i class="close-btn" v-if="!videoExitBtn" @click.stop="closeMediaFullscreen()"></i>
          <img v-if="videoExitBtn" class="exitPlay" @click.stop="exitPlay()" src="../assets/img/pc/exitPlay.png" alt="">
        </div>
      </div>
    </transition>

      <!-- 视频集蒙层 -->
     <transition name="cover">
      <div class="main-cover" id="videoSetBox" v-if="videoSetShow" @click.stop="closeMediaFullscreen('videoSetShow')">
          <video-set
            :pluginJson="pluginJson"
        :pluginIndex="pluginIndex"></video-set>
          <i class="close-btn" @click.stop="closeMediaFullscreen('videoSetShow')"></i>
      </div>
    </transition>

      <!-- TODO 单个图文蒙层 -->
    <transition name="cover">
      <div class="main-cover" id="main-cover-img_text" v-if="singleImgTextShow" @click.stop="closeDialog('singleImgTextShow')">
          <img-text :appInfo="appInfo" @closePage="closeDialog"> </img-text>
      </div>
    </transition>

    <!--TODO 多图片蒙层 -->
    <transition name="cover">

      <div class="main-cover" id="main-cover-img_text" v-if="imgsTextShow" @click.stop="closeMediaFullscreen">
          <img-text-swiper
            :pluginJson="pluginJson"
            :pluginIndex="pluginIndex"
            @closeDialog="closeMediaFullscreen">
          </img-text-swiper>
          <!-- <i class="close-btn" @click="closeSingleImgText()"></i> -->
      </div>
    </transition>

    <!-- TODO  三维轮播蒙层-->
    <transition name="cover">
      <div class="main-cover" id="main-cover-img_text" v-if="threeSwiperShow" @click.stop="closeMediaFullscreen">
          <pano-text-swiper
            :pluginJson="pluginJson"
            :pluginIndex="pluginIndex"
            @closeDialog="closeMediaFullscreen"> </pano-text-swiper>
          <!-- <i class="close-btn" @click="closeSingleImgText()"></i> -->
      </div>
    </transition>
    <!--图片蒙层-->
    <!--时间线  history -->
    <transition name="cover">
      <div class="main-cover" v-if="timeLineFullscreen" @click.stop="closeMediaFullscreen">
        <dizhen-history
          :pluginJson="pluginJson"
          :pluginIndex="pluginIndex"></dizhen-history>
         <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>
    <!--单张图片蒙层-->
    <transition name="cover">
      <div class="main-cover" v-show="singleImgFullscreen" @click.stop="closeMediaFullscreen()">
        <div class="box">
          <div class="singleImg-box">
            <img :src="singleImgUrl">
          </div>
          <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
        </div>
      </div>
    </transition>

    <!--富文本蒙层-->
    <transition name="cover">
      <div class="main-cover main-cover1" v-show="iframeFullscreen">
        <div class="box">
          <div class="iframe-box">
            <iframe v-if="iframeUrl" :src="iframeUrl"></iframe>
            <i class="close-btn" @click="closeMediaFullscreen()"></i>
          </div>
        </div>
      </div>
    </transition>

    <!--文物勋章墙-->
    <transition name="cover">
      <div class="honor-box" v-show="honorShow">
        <div class="title"></div>
        <div class="honor-wall">
          <ul class="clearfix">
            <li v-for="i in 30" :key="i">
              <img src="../assets/img/artboard/artboard-01.png" alt="" :class="i">
            </li>
          </ul>
        </div>
        <i class="close-btn" @click="showHonor(false)"></i>
      </div>
    </transition>

    <!--展览信息蒙层-->
    <transition name="cover">
      <div class="museum-cover" v-show="museumInfoShow">
        <swiper class="area" :options="museumInfoSwiperOptions">
          <swiper-slide class="box">
            <div class="logo"></div>
            <ul class="intro">
              <li>
                <h3>企业简介</h3>
                <h4 style="text-align: justify;" v-html="util.formatTextBr(appInfo.description)"></h4>
              </li>
              <!-- <li>
                <h3>展期</h3>
                <h4>常设展览</h4>
              </li>
              <li>
                <h3>地点</h3>
                <h4>北京首都机场辅路民航200号</h4>
              </li>
              <li>
                <h3>主办单位</h3>
                <h4>民航博物馆</h4>
              </li>
              <li>
                <h3>协办单位</h3>
                <h4>民航华北地区管理局 民航东北地区管理局 </h4>
                <h4>民航华东地区管理局 民航中南地区管理局</h4>
                <h4>民航西南地区管理局 民航西北地区管理局</h4>
                <h4>民航新疆管理局 民航宣传教育中心</h4>
              </li> -->
            </ul>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <i class="close-btn" @click="showMuseumInfo(false)"></i>
      </div>
    </transition>

    <!--图文marker marker介绍非皓月id的类型展示蒙层-->
    <transition name="cover">
      <div class="markerInfoFull-cover" v-if="markerInfoFullContentscreen">
        <div class="intro">
          <h3>{{markerInfo.title}}</h3>
          <div class="textHtml" v-html="markerInfo.content"></div>
        </div>
        <i class="close-btn" @click="markerInfoFullContentscreen = false"></i>
      </div>
    </transition>

    <!--图文混排信息蒙层-->
    <transition name="cover">
      <div class="main-cover textMarker-cover" v-show="textMarkerFullscreen && currentPanoIndex !== 1" @click.stop="closeMediaFullscreen()">
        <swiper class="area" :options="textMarkerSwiperOptions" v-if="textMarkerList.length > 0">
          <swiper-slide class="card-pad card-intro" v-for="(item, index) in textMarkerList" :key="index" :class="{'one': textMarkerList.length === 1}">
            <!-- <div class="logo"></div> -->
            <div draggable="false" class="background"></div>
            <div class="text">
              <div class="title" v-html="item.title"></div>
              <div class="intro-box">
                <vue-scroll>
                  <div class="intro" v-html="item.content"></div>
                </vue-scroll>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>
    <!-- 只有第二张全景上的marker长这样 -->
    <transition name="cover">
      <div class="main-cover textMarker-cover textMarker-cover-one" v-show="textMarkerFullscreen && currentPanoIndex == 1">
        <swiper class="area" :options="textMarkerSwiperOptions" v-if="textMarkerList.length > 0">
          <swiper-slide class="card-pad card-intro" v-for="(item, index) in textMarkerList" :key="index" :class="{'one': textMarkerList.length === 1}">
            <!-- <div class="logo"></div> -->
            <div class="text">
              <div class="title" v-html="item.title"></div>
              <div class="intro-box">
                <vue-scroll>
                  <div class="intro" v-html="item.content"></div>
                </vue-scroll>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
        <i class="close-btn" @click="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <!--品牌信息蒙层-->
    <transition name="cover">
      <div class="brand-cover" v-show="brandInfoShow">
        <div class="logo"></div>
        <div class="intro">
          <br>
          <p>微景天下成立于2015年8月，国家级高新技术企业，公司致力于通过全景和三维视觉技术构建传统文化和现代科技的可视化服务体系。</p>
          <br>
          <p><b>·解决方案提供商：</b>实境城市、数字博物馆、数字展览、文物解析、实境乡村。</p>
          <br>
          <p><b>·技术服务商：</b>供给数据内容、模板服务、定制服务。</p>
          <br>
          <p><b>·支持多端展示：</b>满足更多应用场景；手机H5及小程序、电脑端、电视触屏端、VR等。</p>
        </div>
        <div class="official-web-btn" @click="toOfficialWeb"></div>
        <div class="contact-us-btn"></div>
        <i class="close-btn" @click="showBrandInfo(false)"></i>
      </div>
    </transition>

    <!--纯图片marker图文信息-->
    <transition name="cover">
      <image-page
        ref="markerInfoRef"
        v-show="markerInfo.display"
        :APPID="APPID"
        :show="markerInfo.display"
        :info="markerInfo.info"
        :appInfo="appInfo"
        :visitNum="visitNum"
        :likeNum="likeNum"
        :mainAudioPlay="mainAudioPlay"
        :isLike="isLike"
        :isShowShare="isShowShare"
        @close="closeImagePage">
      </image-page>
    </transition>

    <!--富文本蒙层-->
    <transition name="cover">
      <div class="main-cover" v-show="pdfFullscreen" @click.stop="closeMediaFullscreen()">
        <div class="box">
          <div class="iframe-box pdf-box">
            <pdf
              v-for="i in pdfNumPages"
              :key="i"
              :src="pdfUrl"
              :page="i"
              style="width: 100%"
            ></pdf>
          </div>
          <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
        </div>
      </div>
    </transition>

    <!--漫游蒙层-->
    <div class="roaming-cover" v-show="isRoaming" @click.stop="stopRoaming"></div>

    <!--欢迎页-->
    <transition name="fade">
      <wel-page v-show="mainCoverShow" :url="appInfo.pcCover" :isEnter="!mainCoverShow" @runEnter="playRoamVideo"></wel-page>
      <!--<wel-page v-show="mainCoverShow" :url="appInfo.pcCover" :isEnter="!mainCoverShow" @runEnter="runEnter"></wel-page>-->
      <!--// this.runEnter()-->
    </transition>

    <!--loading-->
    <div class="loading-box" v-show="changingPano">
      <div class="twoCircles">
        <div @click="playVideo">自动导览</div>
        <div @click="playSelf">手动探索</div>
      </div>
      <!-- 进入全景后的loading去掉 换成两个切换按钮 -->
      <!-- <div class="loading-icon-back">
        <div class="loading-icon"></div>
      </div> -->
    </div>

    <!--模拟体验-->
    <!--<transition name="cover">-->
      <!--<div class="imitatediv">-->
        <!--<imitate-play :imitate="imitate" v-if="imitateShow" @closePage="imitateShow = false"></imitate-play>-->
      <!--</div>-->
    <!--</transition>-->

    <!--欢迎页加载-->
    <transition name="fade">
      <load-page v-if="showLoadPage" ></load-page>
    </transition>
    <!--大事记-->
    <transition name="cover">
      <div class="main-cover" v-if="bigEventsShow">
        <bigEvents :pluginJson="pluginJson" @showMedia="showMedia"></bigEvents>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <transition name="cover">
      <div class="main-cover" v-if="topProductsShow">
        <topProducts :pluginJson="pluginJson" @showMedia="showMedia"></topProducts>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <transition name="cover">
      <div class="main-cover" v-if="RdCenterShow">
        <RdCenter :pluginJson="pluginJson" @showMedia="showMedia"></RdCenter>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <transition name="cover">
      <div class="main-cover" v-if="chanDiShow">
        <chanDi :pluginJson="pluginJson" @showMedia="showMedia"></chanDi>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <transition name="cover">
      <div class="main-cover" v-if="jieshaoShow" >
        <jieshao :textMarkerList="textMarkerList"></jieshao>
        <i class="close-btn" @click.stop="closeMediaFullscreen()"></i>
      </div>
    </transition>

    <!--<earth-model v-if="showEarthModel" @closePage="showEarthModel = false"></earth-model>-->
  </div>
</template>

<script>
// import comment from './components/comment'
import welPage from './components/welPage'
import imagePage from './components/imagePage'
import videoSet from '../components/VideoSet'
import imgText from '../components/imgText'
import pdf from 'vue-pdf'
import imgTextSwiper from '../components/imgTextSwiper'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import panoTextSwiper from '../components/panoTextSwiper'
import dizhenHistory from '../components/dizhenHistory'
// import imitatePlay from '../components/imitatePlay'
import loadPage from '../components/loadPage'
// import earthModel from '../components/earth'

// import modelPage from './components/modelPage'
import bigEvents from './components/bigEvents.vue'
import topProducts from './components/topProductsTest'
import RdCenter from './components/RdCenter'
import chanDi from './components/chanDi'
import jieshao from './components/jieshao'

export default {
  name: 'App',
  components: {
    'jieshao': jieshao,
    'chanDi': chanDi,
    'RdCenter': RdCenter,
    'topProducts':topProducts,
    'bigEvents': bigEvents,
    // 'comment': comment,
    'wel-page': welPage,
    'image-page': imagePage,
    'video-set': videoSet,
    'img-text': imgText,
    'img-text-swiper': imgTextSwiper,
    'pano-text-swiper': panoTextSwiper,
    'dizhen-history': dizhenHistory,
    'pdf': pdf,
    // 'imitate-play': imitatePlay,
    'load-page': loadPage
    // 'earth-model': earthModel,
    // 'model-page': modelPage
  },
  data () {
    return {
      recommend: false,
      markerArray: [],
      moveStep: 0,
      moveStepTemp: -1,
      hideMarkerIsModelInit: false,
      hideMarkerPanoIdTemp: '',
      willHideRoamMarker: true,
      jieshaoShow: false,
      chanDiShow: false,
      RdCenterShow: false,
      topProductsShow: false,
      bigEventsShow:false,
      interfaceShowaddr:false,
      // 虚拟场景 显示
      imitateShow: false,
      showLoadPage: false,
      showEarthModel: false,
      imitate: {},
      tipBoxShow: false, // 手动播放提示框
      bgVolume: 1,
      autoPalyList: [0, 1, 30, 12, 16, 28],
      autoPalyIndex: 0,
      changeType: 'normal',
      // APPID: '6037',
      currentPanoIndex: 0,
      // APPID: '2009266904',
      APPID: '2011168547',
      activePano: {},
      time: null, // 定时器暂存
      audioFirstPlay: true,
      // 开关
      interfaceShow: false, // 界面显示开关
      cardFullscreen: false, // 是否显示全屏内容
      mapFullscreen: false, // 地图全屏内容
      videoFullscreen: false, // 视频全屏内容
      iframeFullscreen: false, // 富文本全屏内容
      timeLineFullscreen: false, // 时间线全屏内容
      singleImgFullscreen: false, // 图片全屏内容
      isPageFullScreen: false, // 页面是否全屏
      mainCoverShow: true, // 欢迎页显示开关
      contentCardsShow: true, // 主卡片显示开关
      willExpand: false, // 卡片即将展开指示器
      isShowShare: false, // 是否展示分享盒子开关
      locationListShow: false, // 地图内列表展示开关
      mainAudioPlay: false, // 主音频播放开关
      audioPlayTemp: false, // 音频是否播放暂存器
      infoCardsShow: false, // 二级页详情卡片开关
      markerInfoFullscreen: false, // 图文marker展示开关
      markerInfoFullContentscreen: false, // 图文marker marker介绍非皓月id的类型展示蒙层
      panoIntroShow: true, // 图文信息展示
      panoIntroShowAll: false, // 图文信息全屏
      haveOtherPano: false, // 是否有其他全景
      museumInfoShow: false, // 展览信息蒙层
      textMarkerFullscreen: false, // 图文混排marker蒙层
      textMarkerList: [],
      brandInfoShow: false, // 关于我们蒙层
      honorShow: false, // 文物功勋墙层
      commentInputShow: false, // 评论输入层
      audioDomIsPlaying: false,
      isRoaming: false,
      panoInfoCoverShow: false,
      changingPano: false, // 正在切换全景
      videoExitBtn: false, // video弹框退出播放btn的显隐
      showRightList: true,
      videoSetShow: false, // 视频集合弹窗
      singleImgTextShow: false, // 单个图文
      threeSwiperShow: false, // 三维swiper
      imgsTextShow: false,
      whichShareBtnSelect: 'wx', // 哪一个分享按钮被选中
      // 数据
      appList: {
        appGroupArray: [{
          appEntityArray: [{
            name: ''
          }]
        }]
      },
      appInfo: {
        map: {
          marker: []
        }
      },
      allPanoIdJson: {},
      entityNameList: [],
      entityNameIndex: 0,
      entityNameHoverIndex: null,
      visitNum: 0,
      likeNum: 0,
      isLike: false,
      videoUrl: '',
      autoplay: false,
      singleImgUrl: '',
      iframeUrl: '',
      allPano: {},
      pluginData: {},
      pluginJson: null,
      pluginIndex: '0',
      curPano: {
        id: '',
        level: 1,
        name: ''
      },
      introPano: {
        id: '',
        level: 1,
        name: '',
        baseInfo: null,
        maxIntro: [],
        panoIndex: 0
      },
      panoGroup: [],
      mapSelected: '',
      otherPanoArray: [],
      groupPlugins: {},
      curPanoNorthHeading: 0,
      markerHeadingDifference: 0,
      // 操作数据缓存
      touchDown: false,
      touchLeft: 0,
      k: 0, // 屏幕大小变换时，暂存timeout
      markerInfo: {
        title: '',
        imgUrl: '',
        content: '',
        display: false,
        info: null
      },
      pixelRatio: window.devicePixelRatio || 1,
      comment: '',
      roamingTime: null,
      panoListLineInter: null,
      isDoingSwiper: false,
      museumInfoSwiperOptions: {
        direction: 'vertical',
        initialSlide: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        freeMode: true,
        slidesPerView: 'auto',
        mousewheelControl: true,
        scrollbar: '.swiper-scrollbar'
      },
      textMarkerSwiperOptions: {
        initialSlide: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        freeMode: true,
        slidesPerView: 'auto',
        mousewheelControl: false
      },
      isViewJson: {},
      pdfFullscreen: false,
      pdfNumPages: undefined,
      pdfUrl: '',
      // 音频
      tempEntityId: '',
      baseInfoJson: {
        audioIntro: ''
      },
      audioIntro: '',
      infoAudioPlay: false,
      audioDomIsPlay: false,
      audioTime: {
        per: 0,
        playMinutes: 0,
        totalMinutes: 0,
        interval: null
      },
      idName: ''
    }
  },
  mounted () {
    if (this.util.isMobile()) {
      let url = location.href
      let url1 = url.replace('index.html', 'mobile.html')
      location.href = url1
      return false
    }
    // if (this.util.getUrlParam('appId')) {
    //   this.APPID = '' + this.util.getUrlParam('appId')
    // } else {
    //   alert('缺少appId')
    //   return false
    // }

    // this.showLoadPage = true
    // this.mainCoverShow = true

    window.QRCode.toCanvas(document.getElementById('canvas'), location.href, {
      'width': 96
    })
    window.markerArray = []
    window.mapMarkerArray = []

    this.axios.all([
      this.$api.getAppList(this.APPID),
      this.$api.getAppInfo(this.APPID)
    ]).then(this.axios.spread((appList, appInfo) => {
      this.appList = appList.data.data
      this.appInfo = appInfo.data.data
      this.util.setWechartTitle(this.appInfo.name)
      this.util.addStatistics(this.appInfo.statId, this.appInfo.statCid)
      this.appInfo.map = this.initCustomMap(this.appInfo.map)
      !this.appInfo.pcCover && (this.appInfo.pcCover = '//tiles.pano.vizen.cn/5a1fa30026d67f25359f0a6c/sphere/thumb_360.jpg')
      !this.appInfo.cover && (this.appInfo.cover = '//tiles.pano.vizen.cn/5a1fa30026d67f25359f0a6c/sphere/thumb_360.jpg')
      this.formatData()
      this.markerArray = this.dataArray['visitLineJson']
      // this.initEngine()
      // this.setShare()
      // this.interfaceShow = true
      // document.getElementsByTagName('html')[0].style.background = 'lightblue'
      this.setBgAudio(this.appInfo.bgAudioUrl, true, true)
      this.runEnter()
    }))

    // add
    // this.$api.getAppList(this.APPID).then(res => {
    //   console.log(res.data.data)
    //   // 获取到模拟体验传给子组件
    //   let newarr = res.data.data['appGroupArray']
    //   for (var i = 0; i < newarr.length; i++) {
    //     if (newarr[i]['name'] === '模拟体验') {
    //       this.imitate = newarr[i]
    //       console.log(this.imitate)
    //     }
    //   }
    // })
    // add
    this.getLikeAndVisit()
    this.addVisit()
    this.couldLike()
    /* eslint-disable-next-line */
    window.cardSwiper = new window.Swiper('#panoListSwiper', {
      direction: 'vertical',
      initialSlide: 0,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      freeMode: true,
      slidesPerView: 'auto'
    })

    document.querySelector('body').addEventListener('mouseup', () => {
      if (this.isDoingSwiper) {
        // window.pano.touchable = trueclearMarkers
        this.isDoingSwiper = false
        this.tipBoxShow = false
      }
      if (this.tipBoxShow) {
        this.tipBoxShow = false
      }
    })
  },
  methods: {
    autonomy() {
      console.log('autonomy');
      this.isRoaming = false
      this.recommend = false
      this.switchPanoRoamMarkerHideType(false)
    },
    switchPanoRoamMarkerHideType (boo) {
      this.willHideRoamMarker = boo
      if (boo) {
        this.recommend = true
        this.hideMarkerIsModelInit = true
        this.hidePanoRoamMarker(window.roam.pano.panoId, 'mustHide')
      } else {
        this.recommend = false
        this.hideMarkerIsModelInit = false
        this.hidePanoRoamMarker('', 'mustHide')

      }
    },
    hidePanoRoamMarker (panoId, type) {
      if (!type) {
        if (!this.hideMarkerIsModelInit) {
          return false
        }
        if (!this.willHideRoamMarker) {
          return false
        }
        if (this.hideMarkerPanoIdTemp === panoId) {
          return false
        }
        this.moveStep = this.moveStep + 1
        console.log('this.moveStep', this.moveStep)
      }
      window.roam.clearSplines()
      // 找到所有的marker点panoid
      // 找到该楼层的配置
      let array = this.markerArray['1']
      // 找到当前点位在列表中的index

      let index = -1
      if (array.length > 0) {
        if (array[this.moveStep] === panoId) {
          index = this.moveStep
        } else {
          index = array.findIndex((id) => {
            return id === panoId
          })
        }
      }
      this.moveStepTemp = index
      if (index >= 0) {
        this.moveStep = index
        // 直接隐藏所有marker
        this.util.clearAllRoamMarker(true)
        this.hideMarkerPanoIdTemp = panoId
        if (index - 1 >= 0) {
          let prevPanoId = array[index - 1]
          let panoIndex = this.util.panoId2index(prevPanoId)
          window.roam.hotspots[panoIndex].visible = true
          // window.roam.setHotspotVisible(panoIndex, true)
          window.roam.hotspots.forEach((h) => {
            if (h.index === panoIndex) {
              h.traverse(c => {
                c.material && c.material.color.setHex(0xcccccc)
              })
            }
          })
        }
        // 下两个marker
        if (index + 2 < array.length) {
          let curPanoIndex = this.util.panoId2index(panoId)
          let nextPanoId = array[index + 1]
          let panoIndex = this.util.panoId2index(nextPanoId)
          let nextPanoId2 = array[index + 2]
          let panoIndex2 = this.util.panoId2index(nextPanoId2)

          window.roam.hotspots[curPanoIndex].visible = true
          window.roam.hotspots[panoIndex].visible = true
          window.roam.hotspots[panoIndex2].visible = true
          // window.roam.setHotspotVisible(curPanoIndex, true)
          // window.roam.setHotspotVisible(panoIndex, true)
          // window.roam.setHotspotVisible(panoIndex2, true)
          let pos = [
            window.roam.config.panoInfos[curPanoIndex].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0)),
            window.roam.config.panoInfos[panoIndex].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0)),
            window.roam.config.panoInfos[panoIndex2].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0))
          ]

          window.spline = window.roam.addSpline(pos, 0.08, 20, './images/arrowLine-128.png')

          // 路径动画
          new window.TWEEN.Tween({ x: 2 })
            .to({ x: 0 }, 5000)
            .onUpdate(o => {
              window.spline.material.map.offset.y = o.x
              window.roam.requestDraw()
            })
            .repeat(Infinity)
            .start()
        } else if (index + 1 < array.length) {
          let curPanoIndex = this.util.panoId2index(panoId)
          let nextPanoId = array[index + 1]
          let panoIndex = this.util.panoId2index(nextPanoId)
          // let nextPanoId2 = array[0]
          // let panoIndex2 = this.util.panoId2index(nextPanoId2)
          window.roam.hotspots[curPanoIndex].visible = true
          window.roam.hotspots[panoIndex].visible = true

          // window.roam.setHotspotVisible(curPanoIndex, true)
          // window.roam.setHotspotVisible(panoIndex, true)
          let pos = [
            window.roam.config.panoInfos[curPanoIndex].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0)),
            window.roam.config.panoInfos[panoIndex].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0)),
            // window.roam.config.panoInfos[panoIndex2].hotspot.clone().add(new window.THREE.Vector3(0, 0.1, 0))
          ]

          window.spline = window.roam.addSpline(pos, 0.08, 20, './images/arrowLine-128.png')

          // 路径动画
          new window.TWEEN.Tween({ x: 2 })
            .to({ x: 0 }, 5000)
            .onUpdate(o => {
              window.spline.material.map.offset.y = o.x
              window.roam.requestDraw()

            })
            .repeat(Infinity)
            .start()
        }
      } else {
        // 恢复被隐藏的marker
        this.util.clearAllRoamMarker(false)
        // let panoIndexTemp = this.util.panoId2index(this.hideMarkerPanoIdTemp)
        // if (this.hideMarkerPanoIdTemp && panoIndexTemp !== -1) {
        //   window.landMarkerFiltration[panoIndexTemp].forEach((el, i) => {
        //     window.roam.setHotspotVisible(el, true)
        //   })
        // }
        // 隐藏marker
        // let panoIndex = this.util.panoId2index(panoId)
        // if (window.landMarkerFiltration[panoIndex]) {
        //   console.log('isHide-' + panoId)
        //   this.hideMarkerPanoIdTemp = panoId
        //   window.landMarkerFiltration[panoIndex].forEach((el, i) => {
        //     window.roam.hotspots[el].visible = false
        //     // window.roam.setHotspotVisible(el, false)
        //   })
        // } else {
        //   this.hideMarkerPanoIdTemp = ''
        // }
      }
    },
    changedh(){
      this.interfaceShowaddr=!this.interfaceShowaddr
    },
    playRoamVideo () {
      this.mainCoverShow = false
      this.switchPanoRoamMarkerHideType(true)
      window.roam.videoTextures[window.s1.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s2.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s3.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s4.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s5.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s6.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s7.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s9.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s10.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.sding.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.szy.url].image.webkitPlaysinline = ''
      window.roam.videoTextures[window.s1.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s2.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s3.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s4.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s5.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s6.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s7.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s9.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.s10.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.sding.url].image.x5Playsinline = ''
      window.roam.videoTextures[window.szy.url].image.x5Playsinline = ''

      window.roam.videoTextures[window.s1.url].image.muted = true
      window.roam.videoTextures[window.s2.url].image.muted = true
      window.roam.videoTextures[window.s3.url].image.muted = true
      window.roam.videoTextures[window.s4.url].image.muted = true
      window.roam.videoTextures[window.s5.url].image.muted = true
      window.roam.videoTextures[window.s6.url].image.muted = true
      window.roam.videoTextures[window.s7.url].image.muted = true
      window.roam.videoTextures[window.s9.url].image.muted = true
      window.roam.videoTextures[window.s10.url].image.muted = true
      window.roam.videoTextures[window.sding.url].image.muted = true
      window.roam.videoTextures[window.szy.url].image.muted = true

      window.roam.videoTextures[window.s1.url].image.loop = true
      window.roam.videoTextures[window.s2.url].image.loop = true
      window.roam.videoTextures[window.s3.url].image.loop = true
      window.roam.videoTextures[window.s4.url].image.loop = true
      window.roam.videoTextures[window.s5.url].image.loop = true
      window.roam.videoTextures[window.s6.url].image.loop = true
      window.roam.videoTextures[window.s7.url].image.loop = true
      window.roam.videoTextures[window.s9.url].image.loop = true
      window.roam.videoTextures[window.s10.url].image.loop = true
      window.roam.videoTextures[window.sding.url].image.loop = true
      window.roam.videoTextures[window.szy.url].image.loop = true

      window.roam.videoTextures[window.s1.url].image.play()
      window.roam.videoTextures[window.s2.url].image.play()
      window.roam.videoTextures[window.s3.url].image.play()
      window.roam.videoTextures[window.s4.url].image.play()
      window.roam.videoTextures[window.s5.url].image.play()
      window.roam.videoTextures[window.s6.url].image.play()
      window.roam.videoTextures[window.s7.url].image.play()
      window.roam.videoTextures[window.s9.url].image.play()
      window.roam.videoTextures[window.s10.url].image.play()
      window.roam.videoTextures[window.sding.url].image.play()
      window.roam.videoTextures[window.szy.url].image.play()

    },
    closeDizhenHistory () {
      this.timeLineFullscreen = false
    },
    playVideo () {
      this.videoExitBtn = true
      this.changingPano = false
      this.interfaceShow = false
      this.showMedia({ url: '//1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/3f5723495285890807726561032/v.f100040.mp4', type: 'video' })
      this.autoplay = true
    },
    closeDialog (type) {
      this[type.page] = false
    },
    playSelf () {
      this.changingPano = false
      this.setInterface(true)
      this.tipBoxShow = true
    },
    exitPlay () {
      this.videoExitBtn = false
      this.closeMediaFullscreen()
      this.setInterface(true)
    },
    findFacityIdBypanoId (panoId) {
      console.log('findFacityIdBypanoId', panoId)
      // this.hideMarkerIsModelInit = true
      this.hidePanoRoamMarker(panoId)
      this.curPano = this.allPano[this.allPanoIdJson[panoId]]
      this.activePano = this.curPano
      this.entityNameIndex = this.curPano.entityIndex
      if (!this.baseInfoJson[this.curPano.entityId]) {
        this.$api.getEntityInfo(this.curPano.entityId).then(res => {
          // this.baseInfoJson[this.curPano.entityId] = res.data.data
          this.$set(this.baseInfoJson, this.curPano.entityId, res.data.data)
          this.changeAudio('singleInfoAudio')
        })
      } else {
        if (this.curPano.entityId !== this.tempEntityId) {
          this.changeAudio('singleInfoAudio')
        }
      }
      this.tempEntityId = this.curPano.entityId
      this.setPano(this.allPanoIdJson[panoId], panoId)
    },
    // 首次点击时触发音乐播放
    playAudio () {
      if (this.audioFirstPlay) {
        document.getElementById('audioDom').play()
        this.audioFirstPlay = false
      }
    },
    customMapMarkerClick (marker) {
      this.toPanoPage(marker.properties.facilityId)
    },
    // 设置分享
    setShare () {
      let shareUrl = null
      let shareTitle = this.appInfo.shareTitle
      let shareDesc = this.appInfo.shareDesc
      let shareImg = this.util.checkImageUrl(this.appInfo.logo || this.appInfo.thumbnail)
      window.getShareInfoSub(shareUrl, shareTitle, shareDesc, shareImg)
    },
    // 初始化引擎
    initEngine () {
      let container = document.getElementById('appContainer')
      window.pano = new window.vizengine.PanoView(container)
      window.pano.setOnClick(() => {
        this.isShowShare = false
        this.interfaceShow = !this.interfaceShow
        this.showMarker(this.interfaceShow)
        // this.window.panoClickLogic()
      })
      // let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      // panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      // this.activePano = panoInfo
      // let panoId = panoInfo.panoId
      let panoInfo = {}
      let panoId = '342996D547794BCF98288F79FA7617C1'
      if (this.util.env().testEnv) {
        panoId = '[TT]' + panoId
      }
      window.pano.setPanoIdAndFilterName(panoId, '', () => {
        window.pano.setHeading(panoInfo.heading || 0)
        window.pano.setPitch(panoInfo.pitch || 0)
        // window.pano.setRoll(123)
        this.util.panoInter(true)
      })
      // this.interfaceShow = true
      this.setPanorequestDraw()
    },
    // 初始化漫游引擎
    initRoamingEngine () {
      this.hideMarkerIsModelInit = false

      let self = this
      let container = document.getElementById('appContainer')
      window.roam = new window.vizengine.RoamView(container)
      // window.roam.setRawModelHost('./resources/cos_root/scenes/', './resources/cos_root/scenes/')
      window.roam.setRawModelHost('//webapp.vizen.cn/vizengine3/pano_roaming/cos_root/scenes/')
      // roam.setRawModelHost('./resources/cos_root/scenes/', './resources/cos_root/scenes/');
      window.grayMat = new window.THREE.MeshPhongMaterial({ color: 0x202020, side: window.THREE.DoubleSide, emissive: 0x404040 })
      // 如果换箭头图片，使用
      window.roam.setHotspotSrc('//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmarker-shadow.png', '//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmarker-shadow.png')
      window.roam.setHotspotSize(2.5)
      // window.roam.setHotspotSrc('//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmark-arrow-thick.png', '//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmark-arrow-thick.png')
      // window.roam.setHotspotSrc('//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmarker-shadow.png', '//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmarker-shadow.png')
      // window.roam.setHotspotSrc('//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmark-arrow.png', '//webapp.vizen.cn/vizengine3/pano_roaming/resources/landmark-arrow.png')
      // window.roam.setHotspotSize(1.5)
      // window.roam.setHotspotModelVisible(false)
      window.roam.setRoamId('quwo', () => {
        setTimeout(() => {
          window.roam.pano.skybox.visible = true
          // window.roam.setPitchRange(-25, 21)
          // this.showLoadPage = false
          // this.mainCoverShow = true
        }, 1000)
        /* eslint-disable */
        // window.s1 = roam.loadScreen('./resources/ea/01/', '01', './resources/ea/Video4.mp4', 960, 540);
        // window.s2 = roam.loadScreen('./resources/ea/02/', '02', './resources/ea/Video3.mp4', 960, 540);
        // window.s3 = roam.loadScreen('./resources/ea/03/', '03', './resources/ea/Video2.mp4', 960, 540);
        // window.s4 = roam.loadScreen('./resources/ea/04/', '04', './resources/ea/Video1.mp4', 960, 540);
        // //视频展示
        // s4.onclick = () => {
        //   this.showEarthModel = true
        // }
        //
        let _this=this

        window.s1 = window.roam.loadScreen('./resources/quwo/screens/', '01', './resources/quwo/videos/1-3.mp4', 960, 540);
        // window.s1 = window.roam.loadScreen('./resources/quwo/screens/', '01', 'http://1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/571a7eba5285890811440432230/v.f100040.mp4', 960, 540);
        // console.log('s1.url',window.s1)
        // setTimeout( () =>{
        //   let videoDom1 = roam.videoTextures[s1.url].image;videoDom1.play();
        // },500)

        s1.onclick = function () {
          window.open('https://my-h5news.app.xinhuanet.com/h5activity/yunzhibo-pc/#/?isFull=0&roomId=5f090f37e4b0692760b0fb9f&articleId=c99f0bd6391f4f6086707a1d39e266a6&share_device_token=e696ccce1862e4979c1d3049603eee58&share_time=1594451922383&share_type=1', '_blank')
        }

        window.s2 = window.roam.loadScreen('./resources/quwo/screens/', '02', './resources/quwo/videos/2-8.mp4', 960, 540);
        // setTimeout( () =>{
        //   let videoDom2 = window.roam.videoTextures[s2.url].image; videoDom2.play();
        // },500)
        s2.onclick = function () {
          _this.pluginJson = _this.pluginData['区域品牌大事记-1-#4']

          _this.bigEventsShow=true
        }
        // s2.onclick = function () { let videoDom = window.roam.videoTextures[s2.url].image; videoDom.play(); }
        //
        // window.s3 = window.roam.loadScreen('./resources/quwo/screens/', '03', './resources/quwo/videos/2-7.mp4', 960, 540);
        window.s3 = window.roam.loadScreen('./resources/quwo/screens/', '03', 'http://1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/a63316c05285890811441501436/v.f100040.mp4', 960, 540);
        // // s3.onclick = function () { let videoDom = window.roam.videoTextures[s3.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom3 = window.roam.videoTextures[s3.url].image; videoDom3.play();
        // },500)
          s3.onclick = function(){
            _this.showMedia({ url: 'http://1251448083.vod2.myqcloud.com/9413fea3vodgzp1251448083/75776b545285890811953645916/Ac4r15gNLhYA.mp4', type: 'video' })
          }
        //
        window.s4 = window.roam.loadScreen('./resources/quwo/screens/', '04', './resources/quwo/videos/2-6.mp4', 960, 540);
        // // s4.onclick = function () { let videoDom = window.roam.videoTextures[s4.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom4 = window.roam.videoTextures[s4.url].image; videoDom4.play()
        // },500)
        s4.onclick = function () {
          _this.pluginJson = _this.pluginData['重点产品-1-#3']

          _this.topProductsShow=true
        }
        //
        window.s5 = window.roam.loadScreen('./resources/quwo/screens/', '05', './resources/quwo/videos/2-5.mp4', 960, 540);
        // // s5.onclick = function () { let videoDom = window.roam.videoTextures[s5.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom5 = window.roam.videoTextures[s5.url].image; videoDom5.play();
        //
        // },500)
        s5.onclick = function () {
          _this.pluginJson = _this.pluginData['重点产品-1-#3']
          _this.topProductsShow=true
        }
        //
        window.s6 = window.roam.loadScreen('./resources/quwo/screens/', '06', './resources/quwo/videos/2-4.mp4', 960, 540);
        // // s6.onclick = function () { let videoDom = window.roam.videoTextures[s6.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom6 = window.roam.videoTextures[s6.url].image; videoDom6.play();
        // },500)
        s6.onclick = function () {
          _this.pluginJson = _this.pluginData['特色产业-2-#2']
          _this.RdCenterShow=true
        }
        //
        window.s7 = window.roam.loadScreen('./resources/quwo/screens/', '07', './resources/quwo/videos/2-3.mp4', 960, 540);
        // window.s7 = window.roam.loadScreen('./resources/quwo/screens/', '07', 'https://1251448083.vod2.myqcloud.com/9413fea3vodgzp1251448083/81268fce5285890811478302990/gM0sneW64jcA.mp4', 960, 540);
        // // s7.onclick = function () { let videoDom = window.roam.videoTextures[s7.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom7 = window.roam.videoTextures[s7.url].image; videoDom7.play();
        // },500)
        s7.onclick = function(){
          _this.showMedia({ url: 'http://1251448083.vod2.myqcloud.com/9413fea3vodgzp1251448083/548abe225285890812005255642/TX87N1SdGAgA.mp4', type: 'video' })
        }
        window.s8 = window.roam.loadScreen('./resources/quwo/screens/', '08', './resources/quwo/videos/sc.png', 960, 540);
        // // s8.onclick = function () { let videoDom = window.roam.videoTextures[s8.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom8 = window.roam.videoTextures[s8.url].image; videoDom8.play();
        // },500)
        s8.onclick = function () {
          _this.pluginJson = _this.pluginData['特色产业-1-#1']

          _this.chanDiShow=true
        }
        //
        //
        window.s9 = window.roam.loadScreen('./resources/quwo/screens/', '09', './resources/quwo/videos/2-1.mp4', 960, 540);
        // // s9.onclick = function () { let videoDom = window.roam.videoTextures[s9.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDom9 = window.roam.videoTextures[s9.url].image; videoDom9.play();
        // },500)
        s9.onclick = function () {
          _this.pluginJson = _this.pluginData['区域简介-1-#1']
          _this.chanDiShow=true
        }
        //
        //
        window.s10 = window.roam.loadScreen('./resources/quwo/screens/', '10', './resources/quwo/videos/1-2.mp4', 960, 540);

        s10.onclick = function () {
          window.open('https://720yun.com/t/9cvkO7r7s7y?scene_id=55512983', '_blank')
        }

        window.sding = window.roam.loadScreen('./resources/quwo/screens/', 'ding1', './resources/quwo/videos/1-0.mp4', 960, 540);
        // // sding.onclick = function () { let videoDom = window.roam.videoTextures[sding.url].image; videoDom.play(); }
        // setTimeout( () =>{
        //   let videoDomd = window.roam.videoTextures[sding.url].image; videoDomd.play();
        // },500)
        // window.szy =window.roam.loadScreen('./resources/quwo/screens/', 'zongyang', './resources/quwo/videos/1-1.mov', 960, 540);
        // window.szy =window.roam.loadScreen('./resources/quwo/screens/', 'zongyang', 'http://1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/22881e0c5285890811225987052/v.f100040.mp4', 960, 540);
        window.szy =window.roam.loadScreen('./resources/quwo/screens/', 'zongyang', './resources/quwo/videos/1-1.mp4', 960, 540)
        // window.szy =window.roam.loadScreen('./resources/quwo/screens/', 'zongyang', 'http://1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/da161d2c5285890811438791530/v.f100040.mp4', 960, 540);

        // setTimeout(() => {
        //   let videoDomzy = window.roam.videoTextures[szy.url].image;
        //   videoDomzy.play();
        // },500)
        szy.onclick = function () {
          // _this.showMedia({ url: './resources/quwo/videos/1-1.mp4', type: 'video' })
          _this.showMedia({ url: 'http://1251448083.vod2.myqcloud.com/483ba14bvodtransgzp1251448083/9fb634b15285890811441278964/v.f100040.mp4', type: 'video' })
        }


        /* eslint-enable */
      })

      // 全景跳转，载入新全景的回调。可以通过roam.pano.panoId获取当前的全景Id
      window.roam.onPanoLoaded = () => {
        let index2 = self.util.panoId2index(window.roam.pano.panoId)
        self.currentPanoIndex = index2
        // 主要逻辑为全景加载后通过panoId反查节点id下的附加信息（包括地点，设施）
        self.findFacityIdBypanoId(window.roam.pano.panoId)
      }


      // window.roam.onHotspotsLoaded = () => {
      //   // 隐藏一些marker
      //   this.util.loadRoamFile(this.groupArray.length - this.floorSelect - 1, () => {
      //     this.hideMarkerIsModelInit = true
      //     this.hidePanoRoamMarker(window.roam.pano.panoId)
      //     this.moveStep = 0
      //   })
      // }

      // 准备切换全景前的操作
      let _this=this
      window.roam.onReadyToMove = function (index) {
        _this.isShowShare=false
        window.roam.clearMarkers()
        window.roam.loadPano(index)
      }

      this.setMiniMapRotate()
    },
    // 进入全景
    runEnter () {
      // this.changingPano = true
      this.changingPano = false
      this.setInterface(true)
      this.tipBoxShow = true
      // this.mainCoverShow = false
      // setTimeout(() => {
      //   this.setInterface(true)
      //   // this.util.panoInter(true)
      // }, 800)
      // this.setInterface(false)
      // 当前焦点全景
      // this.setPano(this.panoGroup[0])
      // let panoInfo = this.allPano[this.panoGroup[0]].panoInfo
      // panoInfo.facilityId = this.allPano[this.panoGroup[0]].facilityId
      // this.activePano = panoInfo
      // 欢迎页要播放背景音乐，之前初始化模型的过程会加载全景，而加载全景后会进行音乐的播放，所以点击进入的时候再设置
      this.makeMainInfo()
      this.initRoamingEngine()
      console.log(window.roam)

    },
    // 通过panoId设置curPano（用于地图列表点击跳转）
    // 通过panoId设置curPano
    setCurPanoWithPanoId (id) {
      console.log('panoId',id)
      // 地图相关
      let index = this.util.panoId2index(id)
      console.log('id',index)
      this.currentPanoIndex = index
      window.roam.clearMarkers()
      window.roam.loadPano(index)

      if(id == '088586E897FB4925A33A2AE24210FED5'){
        window.roam.setHeading(1.1882)
        window.roam.setPitch(0.5026)
      }
      if(id == '9BC484E0660B4E6797A3CB6BEE8C2B0C'){
        window.roam.setHeading(269.7883)
        window.roam.setPitch(0.1698)
      }
      if(id == 'BBA8B96C072048CA8847118A7550B3A3'){
        window.roam.setHeading(359.6427)
        window.roam.setPitch(8.6510)
      }
      if(id == 'A72B9CF4B8F8467385FB79EBEE3CBFF0'){
        window.roam.setHeading(0.8400)
        window.roam.setPitch(7.4762)
      }
      if(id == '3A72015F74924308BB0DF199199D2878'){
        window.roam.setHeading(96.2505)
        window.roam.setPitch(3.4625)
      }

    },
    // 设置小地图方向
    setMiniMapRotate () {
      let self = this
      window.roam.onHeadingChangeCallback = (heading) => {
        this.util.throttle(() => {
          heading = heading % 360
          if (heading < 0) {
            heading += 360
          }
          if (this.appInfo.map && this.appInfo.map.marker && this.appInfo.map.marker.length > 0) {
            let data = JSON.parse(JSON.stringify(this.appInfo.map.marker))
            data.forEach(item => {
              let rate = heading - item.heading
              rate = heading.toFixed(2)
              rate = rate % 360
              if (rate < 0) {
                rate += 360
              }
              item.orientation = rate + item.defaultOrientation
            })
            this.appInfo.map.marker = data
          }
          // console.log('self.$refs',self.$refs)
          self.$refs.radar.style.transform = 'rotateZ(' + (heading + 90) + 'deg)'
        }, 50)
      }
    },
    // 设置地图圆点位置
    // setMapCircle (coordinate) {
    //   if (coordinate) {
    //     let array = coordinate.split(':')
    //     // this.$refs.radarBox.style.left = array[0] + '%'
    //     // this.$refs.radarBox.style.top = array[1] + '%'
    //     // this.$refs.radarBoxBig.style.left = array[0] + '%'
    //     // this.$refs.radarBoxBig.style.top = array[1] + '%'
    //     let mapBoxLeft = -1 * array[0] + '%'
    //     let mapBoxTop = -1 * array[1] + '%'
    //     this.$refs.mapBox.style.transform = `translate3D(${mapBoxLeft}, ${mapBoxTop}, 0)`
    //   }
    // },
    // 获取设施信息
    getEntityInfo (i, length, curPanoId) {
      if (i < length) {
        let id = this.allPano[curPanoId].entityArray[i]
        this.$api.getEntityInfo(id).then(res => {
          let info = res.data.data
          this.allPano[id].baseInfo = info
          let json = {}
          json['intro'] = info.intro
          json['plans'] = info.plans
          this.allPano[curPanoId].maxIntro.push(json)
          this.getEntityInfo((i + 1), length, curPanoId)
        })
      } else {
        this.curPano = this.allPano[curPanoId]
        this.introPano = this.curPano
      }
    },
    // 跳转应用下实体关联的全景图
    tempSetPano (index) {
      // panoGroup 应用下全景地点的entityid数组
      let id = this.panoGroup[index]
      // allPano 所有全景对象 key panoid 值为全景信息
      let panoId = this.allPano[id].panoInfo.panoId
      // 实体索引
      this.entityNameIndex = index

      this.setCurPanoWithPanoId(panoId)
    },
    // 列表鼠标移入
    listMouseOver (index) {
      this.entityNameHoverIndex = index
    },
    // 列表鼠标移出
    listMouseOut (index) {
      this.entityNameHoverIndex = null
    },
    // 设置全景
    // 设置全景
    setPano (id, panoId, type, callback) {
      let that = this
      // if (panoId) {
      //   if (that.curPano.id === id && that.curPano.panoId === panoId) {
      //     return
      //   }
      // } else {
      //   if (that.curPano.id === id) {
      //     return
      //   }
      // }
      this.showPanoList = false
      if (that.interfaceShow) {
        // that.changingPano = false
      }
      let panoIndex = 0
      // 数据处理操作
      let tempFun = () => {
        if (that.curPano.level === 1) {
          // getMaxIntro(id)
          // that.setMapCircle(that.curPano.left, that.curPano.top)
        } else if (that.curPano.level === 2) {
          if (!that.allPano[that.curPano.parentId].baseInfo) {
            that.$api.getEntityInfo(that.curPano.parentId).then(res => {
              that.allPano[that.curPano.parentId].baseInfo = res.data.data
              // getMaxIntro(that.curPano.parentId)
              // that.setMapCircle(that.curPano.left, that.curPano.top)
            })
          } else {
            // getMaxIntro(that.curPano.parentId)
            // that.setMapCircle(that.curPano.left, that.curPano.top)
          }
        }
        if (!that.panoIntroShowAll && !that.changingPano) {
          that.setInterface(true)
          that.util.panoInter(true)
        }
        that.addMarker(id, panoIndex)
        if (that.infoAudioPlay) {
          setTimeout(() => {
            document.getElementById('introAudioDom').play()
          }, 500)
        }
        // that.changingPano = false
        // window.pano.setAutoPlayEnable(false)
        callback && callback()
      }
      // 场景转换和获取基本信息（此处可优化删除掉，之前留下是因为客户可能需要单独设置全景视角以及音频等附加信息，现在设置视角可以在loadpano的回调内设置）
      let setNewPanoHeading = () => {
        // 场景转换
        if (that.curPano.baseInfo) {
          tempFun()
          if (that.curPano.baseInfo.audioIntro && that.curPano.type === 'entity') {
            // this.setAudio(that.curPano.baseInfo.audioIntro)
          }
          // if (that.curPano.type === 'entity') {
          //   that.getArticleInfo(that.allPano[id].baseInfo.intro, (articleInfo) => {
          //     that.allPano[id]['panoListInfo'] = articleInfo.content
          //   })
          // }
        } else {
          if (that.curPano.type === 'entity') {
            that.$api.getEntityInfo(id).then(res => {
              that.allPano[id].baseInfo = res.data.data
              // if (that.allPano[id].baseInfo.intro) {
              //   that.getArticleInfo(that.allPano[id].baseInfo.intro, (articleInfo) => {
              //     that.allPano[id]['panoListInfo'] = articleInfo.content
              //     that.formPanoListInfo()
              //   })
              // }
              if (that.curPano.baseInfo.audioIntro) {
                // this.setAudio(that.curPano.baseInfo.audioIntro)
              }
              tempFun()
            })
          }
          if (that.curPano.type === 'facility') {
            that.$api.getFacilityInfo(id).then(res => {
              that.allPano[id].baseInfo = res.data.data
              tempFun()
            })
          }
        }
      }
      // 处理marekr类型。-图文结尾为皓月文章， -PDF结尾为pdf
      // 是否已存在marker信息，没有时去获取
      let willGetPanoMarker = () => {
        if (that.allPano[id].markerInfo === null) {
          that.$api.getPanoMarker({ facilityId: that.allPano[id].facilityId, materialId: that.allPano[id].panoArray[0].materialId }).then(res => {
            res.data.data.marker.forEach((item, index) => {
              // if (item.type === 'info') {
              //   if (item.name.endsWith('-图文')) {
              //     item.type = 'text' // 文章类型marker
              //     item.name = item.name.replace('-图文', '') // 文章类型marker
              //   }
              //   if (item.name.endsWith('-URL')) {
              //     item.type = 'openUrl' // 文章类型marker
              //     item.name = item.name.replace('-URL', '') // 文章类型marker
              //   }
              //   if (item.name.endsWith('-PDF')) {
              //     item.type = 'PDF' // pdf类型marker
              //     item.name = item.name.replace('-PDF', '') // pdf类型marker
              //   }
              // }
              that.allPano[id].markerInfo = res.data.data
              setNewPanoHeading()
            })
          })
        } else {
          setNewPanoHeading()
        }
      }

      // 最先执行
      if (type === 'marker') {
        willGetPanoMarker()
      } else {
        setTimeout(() => {
          willGetPanoMarker()
        }, 800)
      }
    },
    getArticleInfo (id, callback) {
      if (!id) {
        let data = []
        callback && callback(data)
        return
      }
      let ids = id.split('，')
      // ids = [...ids, ...ids, ...ids, ...ids]
      let length = ids.length
      let successNum = 0
      let data = []
      for (let index = 0; index < ids.length; index++) {
        this.$api.getArticle(ids[index]).then(res => {
          successNum++
          data.push(res.data.data)
          if (successNum === length) {
            callback && callback(data)
          }
        })
      }
    },
    // 获取皓月文章详情，因为多篇有顺序，所以暂时用了一个递归，可优化使用promise.all实现
    getArticleInfoForMarker (id, callback) {
      if (!id) {
        let data = []
        callback && callback(data)
        return
      }
      if(ids.indexOf('，')>-1){
        let ids = id.split('，')
        // ids = [...ids, ...ids, ...ids, ...ids]
        this.articleIndex = 0
        this.articleData = []
      }
      this.getArticleDetail(ids, callback)
    },
    getArticleDetail (ids, callback) {
      if(ids instanceof Array){
        this.$api.getArticle(ids[this.articleIndex]).then(res => {
          this.articleData.push(res.data.data)
          if (this.articleIndex === (ids.length - 1)) {
            callback && callback(this.articleData)
            return
          }
          this.articleIndex++
          this.getArticleDetail(ids, callback)
        })
      }else{
        this.$api.getArticle(ids).then(res => {
          console.log(res.data.data)
          this.articleData.push(res.data.data)
          callback && callback(this.articleData)
          return
        })
      }
    },
    getPanoNorthHeading (facilityId) {
      let data = 0
      this.appInfo.map.marker.forEach((item) => {
        if (item.properties.facilityId === facilityId) {
          data = item.orientation
        }
      })
      return data
    },
    initCustomMap (data) {
      if (!data) {
        return data
      }
      data.marker.forEach((item) => {
        item.left = parseFloat(item.abscissa)
        item.top = parseFloat(item.ordinate)
        item.defaultOrientation = item.orientation || 0
      })
      return data
    },
    // 处理数据
    formatData () {
      // 整理应用结构，六层结构，逐级循环
      this.appList.appGroupArray.forEach((appGroupEle, appGroupIdx) => {
        if (appGroupEle.name === '') {
          appGroupEle.appEntityArray.forEach((appEntityEle, appEntityIdx) => {
            this.allPano[appEntityEle.id] = this.util.initData(appEntityEle, 1)
            this.allPano[appEntityEle.id]['markerInfo'] = null
            this.allPano[appEntityEle.id]['maxIntro'] = []
            this.allPano[appEntityEle.id]['panoIndex'] = appGroupIdx
            this.allPano[appEntityEle.id]['type'] = appEntityEle.type
            this.allPano[appEntityEle.id]['entityIndex'] = appGroupIdx
            this.allPano[appEntityEle.id]['autoPlayDirection'] = 'right'
            if (appEntityEle.tags && appEntityEle.tags.length > 0) {
              this.allPano[appEntityEle.id]['autoPlayDirection'] = appEntityEle.tags[0]
            }
            // 分别处理自动播放时，旋转方向（默认顺时针因接口没有返回子实体标签所以有的用标签判断，有的用拓展链接）， 当前全景的停留时间，进入后暂停几秒开始旋转，自动旋转几秒后停止旋转
            if (appEntityEle.extUrl) {
              this.allPano[appEntityEle.id]['autoPlayDirection'] = 'left'
            }
            if (!appEntityEle.extName) {
              appEntityEle.extName = ''
            }
            this.allPano[appEntityEle.id]['autoPlayTime'] = window.parseInt(appEntityEle.extName.split('，')[0]) || 20
            if (appEntityEle.extName.split('，').length > 1) {
              this.allPano[appEntityEle.id]['runInterStopTime'] = window.parseInt(appEntityEle.extName.split('，')[1])
            } else {
              this.allPano[appEntityEle.id]['runInterStopTime'] = 1
            }
            if (appEntityEle.extName.split('，').length > 2) {
              this.allPano[appEntityEle.id]['panoRunTime'] = window.parseInt(appEntityEle.extName.split('，')[2])
            } else {
              this.allPano[appEntityEle.id]['panoRunTime'] = window.parseInt(appEntityEle.extName.split('，')[0]) || 20
            }
            this.panoGroup.push(appEntityEle.id)
            this.entityNameList.push(appEntityEle.name)
            let facilityArray = []
            let entityArray = []
            if (appEntityEle.appreanceInfo.pano) {
              appEntityEle.appreanceInfo.pano.forEach((pano, panoIndex) => {
                this.allPanoIdJson[pano.panoId] = appEntityEle.id
              })
            }
            appEntityEle.groupArray.forEach((groupEle, groupIdx) => {
              groupEle.materialArray.forEach((materialEle, materialIdx) => {
                this.allPano[materialEle.id] = this.util.initData(materialEle, 2)
                this.allPano[materialEle.id]['markerInfo'] = null
                this.allPano[materialEle.id]['parentId'] = appEntityEle.id
                this.allPano[materialEle.id]['type'] = materialEle.type
                this.allPano[materialEle.id]['entityIndex'] = appGroupIdx
                this.allPano[materialEle.id]['autoPlayDirection'] = 'right'
                // 分别处理自动播放时，旋转方向（默认顺时针因接口没有返回子实体标签所以有的用标签判断，有的用拓展链接）， 当前全景的停留时间，进入后暂停几秒开始旋转，自动旋转几秒后停止旋转
                if (materialEle.tags && materialEle.tags.length > 0) {
                  this.allPano[materialEle.id]['autoPlayDirection'] = materialEle.tags[0]
                }
                if (!materialEle.extName) {
                  materialEle.extName = ''
                }
                this.allPano[materialEle.id]['autoPlayTime'] = window.parseInt(materialEle.extName.split('，')[0]) || 20
                if (materialEle.extName.split('，').length > 1) {
                  this.allPano[materialEle.id]['runInterStopTime'] = window.parseInt(materialEle.extName.split('，')[1])
                } else {
                  this.allPano[materialEle.id]['runInterStopTime'] = 1
                }
                if (materialEle.extName.split('，').length > 2) {
                  this.allPano[materialEle.id]['panoRunTime'] = window.parseInt(materialEle.extName.split('，')[2])
                } else {
                  this.allPano[materialEle.id]['panoRunTime'] = window.parseInt(materialEle.extName.split('，')[0]) || 20
                }
                if (materialEle.type === 'facility') {
                  facilityArray.push(materialEle.id)
                  if (materialEle.pano) {
                    materialEle.pano.forEach((pano, panoIndex) => {
                      this.allPanoIdJson[pano.panoId] = materialEle.id
                    })
                  }
                }
                if (materialEle.type === 'entity') {
                  entityArray.push(materialEle.id)
                  if (materialEle.appreanceInfo.pano) {
                    materialEle.appreanceInfo.pano.forEach((pano, panoIndex) => {
                      this.allPanoIdJson[pano.panoId] = appEntityEle.id
                    })
                  }
                }
              })
            })
            this.allPano[appEntityEle.id]['entityArray'] = entityArray
            this.allPano[appEntityEle.id]['facilityArray'] = facilityArray
          })
        } else {
          if (appGroupEle.name === '数据') {
            appGroupEle.appEntityArray[0].groupArray.forEach((groupEle, groupIdx) => {
              this.pluginData[groupEle.name] = groupEle.materialArray
            })
          }
        }
      })
      console.log('pluginData',this.pluginData)
      console.log('allPanoIdJson',this.allPanoIdJson)
    },
    // 重置全景宽高，避免横竖屏显示bug
    setPanorequestDraw () {
      window.addEventListener('resize', () => {
        clearTimeout(this.k)
        this.k = setTimeout(() => {
          window.pano.requestDraw()
        }, 300)
      }, false)
    },
    // 处理主页界面内内容
    makeMainInfo () {
      // this.setMapCenter(this.allPano[this.mainEntityId].lnglat)
      // this.setAudio(this.appInfo.bgAudioUrl)
      // this.addMarker(this.mainEntityId, 0)
      // this.addMapMarker()
    },
    // 设置音频 当前为双audio标签，部分浏览器上会存在问题可使用AudioContext解决 示例https://github.com/mdn/webaudio-examples/blob/master/multi-track/index.html没做过兼容测试
    // 当前逻辑为背景音乐一直放，讲解词进入某个单元放某个单元，播放讲解词是降低北京音乐声音
    setAudio (url, autoplay = false, isfrist = false) {
      let self = this
      if (!url) {
        this.mainAudioPlay = false
        return
      }
      let url1 = this.util.setProtocol(url)
      let audioDom = document.getElementById('audioExplain')
      let bgAudioDom = document.getElementById('audioDom')
      if (url1 === audioDom.src) {
        return
      }
      let data2 = setInterval(() => {
        if (self.bgVolume < 0.2) {
          clearInterval(data2)
          return
        }
        bgAudioDom.volume = self.bgVolume - 0.05
        self.bgVolume = self.bgVolume - 0.05
      }, 100)
      setTimeout(() => {
        audioDom.setAttribute('src', url1)
        if (autoplay || this.mainAudioPlay) {
          this.mainAudioPlay = true
          audioDom.play()
          audioDom.onended = function (paams) {
            let data = setInterval(() => {
              if (self.bgVolume >= 0.2) {
                clearInterval(data)
                return
              }
              bgAudioDom.volume = self.bgVolume + 0.05
              self.bgVolume = self.bgVolume + 0.05
            }, 100)
          }
        }
      }, 1000)
    },
    setBgAudio (url, autoplay = false, isfrist = false) {
      if (!url) {
        this.mainAudioPlay = false
        return
      }
      let url1 = this.util.setProtocol(url)
      let audioDom = document.getElementById('audioDom')
      if (url1 === audioDom.src) {
        return
      }
      audioDom.setAttribute('src', url1)
      if (autoplay || this.mainAudioPlay) {
        this.mainAudioPlay = true
        audioDom.play()
      }
    },

    // 背景音乐控制
    bgMusicControl () {
      let audioDom = document.getElementById('audioDom')
      // this.infoAudioPlay = false
      if (this.mainAudioPlay) {
        // document.getElementById('audioExplain').pause()
        audioDom.pause()
        this.mainAudioPlay = false
      } else {
        audioDom.play()
        // document.getElementById('audioExplain').play()
        this.mainAudioPlay = true
      }
    },
    // 获取富文本（设施）详情
    getIframeUrl (id) {
      if (this.allPano[id].baseInfo) {
        let url = this.allPano[id].baseInfo.extUrl
        this.showMedia({ url: url, type: 'iframe' })
      } else {
        this.$api.getFacilityInfo(id).then(res => {
          this.allPano[id].baseInfo = res.data.data
          let url = res.data.data.extUrl
          this.showMedia({ url: url, type: 'iframe' })
        })
      }
    },
    // 播放富媒体，视频、富文本
    showMedia (data) {
      if (this.infoAudioPlay) {
        if (document.querySelector('#' + this.idName)) {
          document.querySelector('#' + this.idName).pause()
        }
        // clearInterval(this.audioTime.interval)
        this.infoAudioPlay = false
      }
      if (data.type=='#1'){
        // 处理数据  开始
        // let nameId = data.name.split('-')[0]
        // this.pluginIndex = data.name.split('#')[1]
        this.pluginJson = this.pluginData[data.name]
        this.chanDiShow=true
        console.log('#1111data.name',data.name)
        console.log('#1111data.name',this.pluginJson)

      }
      if (data.type=='#2'){
        // 处理数据
        // let nameId = data.name.split('-')[0]
        // this.pluginIndex = data.name.split('#')[1]
        console.log('#2222data.name',data.name)

        this.pluginJson = this.pluginData[data.name]
        this.RdCenterShow=true
        console.log('#22222data.name',this.pluginJson)

      }
      if (data.type=='#4'){
        // 处理数据
        console.log('#4444data.name',data.name)
        this.pluginJson = this.pluginData[data.name]
        this.bigEventsShow=true
        console.log('#4444data.name',this.pluginJson)
      }
      if (data.type=='#3'){
        console.log('#33333data.name',data.name)
        this.pluginJson = this.pluginData[data.name]
        this.topProductsShow=true
        console.log('#33333data.name',this.pluginJson)
      }
      // openUrl 类型直接跳外链
      if (data.type !== 'openUrl') {
        this.willPlayOthers()
        // this.util.panoInter(false)
        this.setInterface(false)
      }
      if (this.cardFullscreen) {
        this.$refs.cards.$el.style.opacity = '0'
      }
      if (data.type === 'video') {
        this.autoplay = true
        this.videoUrl = data.url
        this.videoFullscreen = true
      } else if (data.type === 'iframe' || data.type === 'url') {
        window.open(data.url)
        this.util.panoInter(true)
        this.setInterface(true)
        this.othersPlayDone()
        // this.iframeUrl = data.url
        // this.iframeFullscreen = true
      } else if (data.type === 'openUrl') {
        window.open(data.url)
      } else if (data.type === 'markerInfo') {
        this.markerInfo.title = data.data.name
        this.markerInfo.imgUrl = data.data.properties.pic
        this.markerInfo.content = data.data.properties.content
        this.markerInfoFullscreen = true
      } else if (data.type === 'markerInfocontent') { // 图文marker marker介绍非皓月id的类型展示蒙层
        this.markerInfo.title = data.data.name
        this.markerInfo.imgUrl = data.data.properties.pic
        let arr = data.data.properties.content.split(',')
        // marker介绍为皓月id的
        if (arr.length < 2 && typeof parseInt(arr[0]) === 'number') {
          this.$api.getArticle(arr[0]).then(res => {
            this.markerInfo.content = res.data.data.content
          })
        } else { // marker介绍为编辑文字的
          this.markerInfo.content = data.data.properties.content
        }
        this.markerInfoFullContentscreen = true
      } else if (data.type === 'pdf') {
        this.pdfUrl = pdf.createLoadingTask({ url: data.url, CMapReaderFactory })
        this.pdfUrl.promise.then(pdf => {
          this.pdfNumPages = pdf.numPages
        })
        this.pdfFullscreen = true
      } else if (data.type === 'singleImg') {
        this.singleImgUrl = data.url
        this.singleImgFullscreen = true
      } else if (data.type === 'textMarker') {
        //皓月文章列表
        this.getArticleInfoForMarker(data.articleList, (articleInfo) => {
          this.textMarkerList = articleInfo
        })
        // this.textMarkerFullscreen = true
        this.jieshaoShow= true
      } else if (data.type === 'infoGroup') {
        // 图片集
        let nameId = data.name.split('&&')[1].split('#')[0]
        this.pluginIndex = data.name.split('#')[1]
        this.pluginJson = this.pluginData[nameId][0]
        this.imgsTextShow = true
      } else if (data.type === 'videoGroup') {
        // 视频集
        let nameId = data.name.split('&&')[1].split('#')[0]
        this.pluginIndex = data.name.split('#')[1]
        this.pluginJson = this.pluginData[nameId]
        this.videoSetShow = true
      } else if (data.type === 'threeDModelGroup') {
        // 三维模型
        let nameId = data.name.split('&&')[1].split('#')[0]
        this.pluginIndex = data.name.split('#')[1]
        this.pluginJson = this.pluginData[nameId][0]
        this.threeSwiperShow = true
      } else if (data.type === 'timeLine') {
        // 三维模型
        let nameId = data.name.split('&&')[1].split('#')[0]
        this.pluginIndex = data.name.split('#')[1]
        this.pluginJson = this.pluginData[nameId]
        this.timeLineFullscreen = true
      }
    },
    // 关闭富媒体弹窗
    closeMediaFullscreen () {
      this.jieshaoShow=false
      this.chanDiShow=false
      this.RdCenterShow=false
      this.topProductsShow= false
      this.bigEventsShow=false
      this.autoplay = false
      this.videoFullscreen = false
      this.iframeFullscreen = false
      this.timeLineFullscreen = false
      this.markerInfoFullscreen = false
      this.pdfFullscreen = false
      this.singleImgFullscreen = false
      this.textMarkerFullscreen = false
      this.imgsTextShow = false
      this.videoSetShow = false
      this.threeSwiperShow = false
      this.textMarkerList = []
      // if (!this.cardFullscreen) {
      //   this.setInterface(true)
      //   setTimeout(() => {
      //     this.util.panoInter(true)
      //     this.othersPlayDone()
      //   }, 800)
      // } else {
      //   this.$refs.cards.$el.style.opacity = '1'
      // }
      setTimeout(() => {
        this.setInterface(true)
        this.othersPlayDone()
      }, 400)
      this.videoUrl = ''
      this.iframeUrl = ''
    },
    // 即将播放其他内容，停止音频
    willPlayOthers () {
      let audioDom = document.getElementById('audioDom')
      // let audioExplain = document.getElementById('audioExplain')
      this.audioPlayTemp = this.mainAudioPlay
      if (this.mainAudioPlay) {
        audioDom.pause()
        // audioExplain.pause()
        this.mainAudioPlay = false
      }
    },
    // 其他内容播放完毕，重新播放音频
    othersPlayDone () {
      let audioDom = document.getElementById('audioDom')
      // let audioExplain = document.getElementById('audioExplain')
      if (this.audioPlayTemp) {
        audioDom.play()
        // audioExplain.play()
        this.mainAudioPlay = true
      }
    },
    // 带有动画效果的全景跳转
    setAnimationChangePano (data, type) {
      if (this.interfaceShow) {
        this.changingPano = false
      }
      this.markerHeadingDifference = this.curPanoNorthHeading - data.heading
      this.util.startNewPanoAnimation({
        panoView: window.pano,
        toHeading: data.heading,
        // toPitch: data.pitch || window.pano.getPitch(),
        toPitch: 0,
        type: type,
        callback: () => { this.setPano(data.id, data.properties.panoId, 'marker') }
      })
    },
    // 添加marker
    addMarker (id, index) {
      console.log('id',id)
      window.roam.clearMarkers()
      window.markerArray = []
      let mks = this.allPano[id].markerInfo.marker
      if (!mks || mks.length === 0) {
        return
      }
      for (let i = 0; i < mks.length; i++) {
        let mk = mks[i]
        console.log('mks[i]',mks[i])
        // marker
        let marker = this.util.markerWraper(mk)

        if (mk.name.endsWith('-Link')) {
          marker.innerHTML =
            `<div class="marker-circle-link">
            <img src="./images/marker-link.png" alt="">
          </div>`
        } else {
          marker.innerHTML =
            `<div class="marker-circle">
            <div class="marker-${mk.type}">
            </div>
          </div>`
        }

        if(mk.type == 'info'){
          if(mk.name.indexOf('#')>-1){
            let name=mk.name.split('-')[0]
            marker.innerHTML =
              `<div class="marker-circle">
            <div class="marker-zhan">
            ${name}
            </div>
          </div>`



          //   if(mk.name.indexOf('#1')>-1){
          //     marker.innerHTML =
          //       `<div class="marker-circle">
          //   <div class="marker-zhan">
          //   ${name}1
          //   </div>
          // </div>`
          //   }

          }

        }


        marker.onclick = () => {
          if (mk.name.startsWith('&&')) {
            if (mk.type === 'info') {
              // 图片集
              this.showMedia({ name: mk.name, type: 'infoGroup' })
            } else if (mk.type === 'video') {
              // 视频集
              this.showMedia({ name: mk.name, type: 'videoGroup' })
            } else if (mk.type === 'audio') {
              // 模拟体验
              this.imitateShow = true
            } else if (mk.type === 'threeDModel') {
              // 三维模型集
              this.showMedia({ name: mk.name, type: 'threeDModelGroup' })
            } else if (mk.type === 'panoVideo') {
              // 时间线
              this.showMedia({ name: mk.name, type: 'timeLine' })
            }
          } else {
            if (mk.type === 'info' && mk.name.endsWith('-#4')){  //大事记
              this.showMedia({ name: mk.name, type: '#4' })
            }else if (mk.type === 'info' && mk.name.endsWith('-#1')){  //产地
              this.showMedia({ name: mk.name, type: '#1' })
            }else if (mk.type === 'info' && mk.name.endsWith('-#2')){  //研发中心
              this.showMedia({ name: mk.name, type: '#2' })
            }else if (mk.type === 'info' && mk.name.endsWith('-#3')){    //代表产品
              this.showMedia({ name: mk.name, type: '#3' })
            }
            if (mk.type === 'info' && mk.name.endsWith('-图文')) {
              // 图文模型
              console.log('mk.properties.content',mk.properties.content)
              this.showMedia({ articleList: mk.properties.content, type: 'textMarker' })
            } else if (mk.type === 'info' && mk.name.endsWith('-Link')) {
              // PDF
              window.open(mk.properties.content, '_blank')
            } else if (mk.type === 'info' && mk.name.endsWith('-PDF')) {
              // PDF
              this.showMedia({
                type: 'pdf',
                url: mk.properties.content.replace(mk.properties.content.substring(0, mk.properties.content.indexOf('/')), location.protocol)
              })
            } else if (mk.type === 'video') {
              this.showMedia({ url: mk.properties.url, type: 'video' })
            } else if (mk.type === 'audio') {
              // 模拟体验
              this.showEarthModel = true
            }
          }
        }
        window.roam.addMarker(marker)
      }
    },
    // 隐藏marker
    showMarker (boo) {
      // window.pano.clearMarkers()
      // if (boo) {
      //   window.markerArray.forEach((el) => {
      //     window.pano.addView(el)
      //   })
      // }
    },
    // 获取喜欢数和浏览数
    getLikeAndVisit () {
      this.$api.getAppZanNum(this.APPID).then(res => {
        this.visitNum = res.data.data.visitCount
        this.likeNum = res.data.data.thumbUpCount
      })
    },
    // 添加浏览数
    addVisit () {
      this.$api.getVisitCount({ 'appId': this.APPID })
    },
    // 是否已喜欢
    couldLike () {
      this.$api.getThumbUpStatus({ 'appId': this.APPID }).then(res => {
        this.isLike = res.data.data
      })
    },
    // 添加喜欢数
    addLike () {
      if (!this.isLike) {
        this.isLike = true
        this.$api.getThumbUpCount({ 'appId': this.APPID }).then(res => {
          if (res.data.code === '0') {
            this.likeNum = this.likeNum + 1
          } else {
            this.isLike = false
          }
        })
      }
    },
    // 设置界面开关
    setInterface (show) {
      this.interfaceShow = show
      // this.showMarker(show)
    },
    // 页面全屏
    setPageFullscreen () {
      if (this.isPageFullScreen) {
        this.exitFullscreen()
      } else {
        this.launchFullscreen()
      }
    },
    // 进入全屏逻辑
    launchFullscreen () {
      let el = document.documentElement
      let rfs = el.requestFullScreen || el.webkitRequestFullScreen ||
        el.mozRequestFullScreen || el.msRequestFullScreen
      if (rfs) { // typeof rfs != "undefined" && rfs
        rfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = true
    },
    // 退出全屏逻辑
    exitFullscreen () {
      let el = document
      let cfs = el.cancelFullScreen || el.webkitCancelFullScreen ||
        el.mozCancelFullScreen || el.exitFullScreen
      if (cfs) { // typeof cfs != "undefined" && cfs
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new window.ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
      this.isPageFullScreen = false
    },
    // 显示全屏地图
    showMap () {
      // this.util.panoInter(false)
      // this.setInterface(false)
      this.mapFullscreen = true
    },
    // 退出全屏展示
    closeMapFullscreen () {
      this.mapFullscreen = false
    },
    // 显示隐藏地图列表
    showLocationList () {
      this.locationListShow = !this.locationListShow
    },
    // 二级卡片操作
    handleTouchStart (event) {
      this.touchDown = true
      // this.setInterface(false)
      this.util.panoInter(false)
      this.touchTop = event.touches[0].clientY
      this.$refs.introTouchArea.style.transition = 'none'
    },
    handleTouchMove (event) {
      if (this.touchDown) {
        let touchMoveTop = event.touches[0].clientY - this.touchTop
        this.$refs.introTouchArea.style.transform = 'translateY(' + touchMoveTop + 'px)'
      }
    },
    handleTouchEnd (event) {
      if (this.touchDown) {
        this.touchDown = false
        this.$refs.introTouchArea.style.transition = 'all 0.6s'
        let touchMoveY = event.changedTouches[0].clientY - this.touchTop
        if (touchMoveY > -60) {
          this.util.panoInter(true)
          this.$refs.introTouchArea.style.transform = 'translateY(0)'
        } else {
          this.setPanoIntroShowAll(true)
          this.$refs.introTouchArea.style.opacity = '0'
          setTimeout(() => {
            this.$refs.introTouchArea.removeAttribute('style')
            this.setInterface(false)
          }, 600)
        }
      }
    },
    updateImgBoxSwiper () {
      /* eslint-disable-next-line */
      new window.Swiper('#imgBoxSwiper',
        {
          direction: 'horizontal',
          initialSlide: 0,
          observer: true, // 修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
          pagination: '.swiper-pagination'
        }
      )
    },
    sendComment () {
      if (this.comment) {
        this.$refs.comment.pushNewComment(this.comment)
        this.comment = ''
        setTimeout(() => {
          this.commentInputShow = false
        }, 0)
      } else {
        this.commentInputShow = false
      }
    },
    toComment () {
      // this.$refs.comment.stopScroll()
      // this.setInterface(false)
      // this.util.panoInter(false)
      this.commentInputShow = !this.commentInputShow
    },
    // 关于我们
    showBrandInfo (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.brandInfoShow = boo
    },
    // 展馆信息
    showMuseumInfo (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.museumInfoShow = boo
    },
    // 分享盒子展示
    setShowShare () {
      this.isShowShare = !this.isShowShare
    },
    showHonor (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.honorShow = boo
    },
    showModel (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.markerInfo.display = boo
    },
    setPanoIntroShowAll (boo) {
      this.setInterface(!boo)
      this.util.panoInter(!boo)
      this.panoIntroShowAll = boo
    },
    toOfficialWeb () {
      location.href = 'http://m.vizen.cn/#/'
    },
    // 自动播放逻辑 根据autoPalyList选择自动播放时要走的全景和顺序，autoPalyList里的值为模型内全景的index值，自动播放逻辑应该为根绝音频或者设计路线编辑实现，当前平台无法支持，路线编辑周博在规划

    todoRoaming (i = window.roam.currentIndex) {
      let that = this
      let time = parseInt(10)
      console.log('i', i)
      console.log('autoPalyList', this.autoPalyList)
      that.autoPalyIndex = this.autoPalyList.findIndex((item) => {
        return i === item
      })
      // let self = this
      // let i = window.roam.currentIndex
      this.isRoaming = true
      // 第一张需要全景来回摆动单独设置，其他根据后台设置进行播放
      let temp = () => {
        this.changeType = 'auto'
        window.roam.setAutoPlayEnable(false)
        setTimeout(() => {
          if (that.curPano.autoPlayDirection !== 'right') {
            window.roam.setAutoPlayEnable(true, true)
          } else {
            window.roam.setAutoPlayEnable(true, false)
          }
          setTimeout(() => {
            window.roam.setAutoPlayEnable(false)
            if (window.roam.currentIndex === 27) {
              window.roam.setAutoPlayEnable(true, true)
              setTimeout(() => {
                window.roam.setAutoPlayEnable(false)
                setTimeout(() => {
                  window.roam.setAutoPlayEnable(true, true)
                }, 18000)
              }, 10000)
            }
          }, that.curPano.panoRunTime * 1000)
          this.roamingTime = setTimeout(() => {
            if (that.autoPalyIndex < that.autoPalyList.length - 1) {
              this.todoRoaming(that.autoPalyList[that.autoPalyIndex + 1])
            } else {
              // autoPalyList中最后一张播放结束停止自动播放后回到模型第一张
              this.stopRoaming()
              window.roam.loadPano(0)
              window.roam.setHeading(0)
              window.roam.setPitch(0)
            }
          }, time * 1000)
        }, that.curPano.runInterStopTime * 1000)
      }

      if (that.autoPalyIndex <= that.autoPalyList.length - 1) {
        let nextAutoplayPanoIndex = that.autoPalyList[that.autoPalyIndex]
        window.roam.loadPano(nextAutoplayPanoIndex, () => {
          that.curPano = that.allPano[that.allPanoIdJson[window.roam.config.panoInfos[nextAutoplayPanoIndex].panoId]]
          console.log('that.curPano.panoArray[0].heading', that.curPano.panoArray[0].heading)
          console.log('that.curPano.panoArray[0].pitch', that.curPano.panoArray[0].pitch)
          if (that.curPano.panoArray[0].heading && that.curPano.panoArray[0].pitch) {
            // 自动播放时需要单独设置视角，pitch现在存在错误值，应该-90 到90的范围平台内如果是负数加了360
            console.log('that.curPano.panoArray[0].heading', that.curPano.panoArray[0].heading)
            window.roam.setHeading(that.curPano.panoArray[0].heading)
            if (that.curPano.panoArray[0].pitch > 90) {
              that.curPano.panoArray[0].pitch = that.curPano.panoArray[0].pitch - 360
            }
            window.roam.setPitch(that.curPano.panoArray[0].pitch)
          }
          time = parseInt(that.curPano.autoPlayTime) || parseInt(10)
          temp()
        })
      }
    },
    setPanoListLineWidth (time, i) {
      let step = 0
      let per = 100 / time
      clearInterval(this.panoListLineInter)
      this.panoListLineInter = setInterval(() => {
        if (per * step >= 100) {
          clearInterval(this.panoListLineInter)
        } else {
          step++
          this.$refs.panoListLine[i].style.width = per * step + '%'
        }
      }, 1000)
    },
    stopRoaming () {
      if (this.roamingTime) {
        clearTimeout(this.roamingTime)
      }
      if (this.panoListLineInter) {
        clearInterval(this.panoListLineInter)
      }
      this.isRoaming = false
      window.roam.setAutoPlayEnable(false)
    },
    showImagePage (plugin) {
      this.setInterface(false)
      this.util.panoInter(false)
      this.markerInfo.info = plugin
      this.markerInfo.display = true
    },
    closeImagePage () {
      this.markerInfo.display = false
      setTimeout(() => {
        this.setInterface(true)
        this.util.panoInter(true)
      }, 800)
    },
    toPanoPage (id) {
      // this.closeMapFullscreen()
      this.setPano(id)
    },
    shareTo (type) {
      let img = ''
      let title = ''
      let content = ''

      // 获取分享标题
      title = this.appInfo.shareTitle || '归来——意大利返还中国流失文物VR展厅'
      // 获取分享内容
      content = this.appInfo.shareDesc || '全景漫游国博首个归来数字展厅，探索归来文物背后的故事。'
      // 获取网页中内容的第一张图片
      img = this.appInfo.logo || this.appInfo.thumbnail

      // 新浪微博接口的传参
      if (type === 'wb') {
        this.whichShareBtnSelect = type
        window.open('http://service.weibo.com/share/share.php?url=http://t.cn/AiW4llWs&shareTitle=' + title + '&shareDesc=' + content + '&thumbnail=' + img + '')
        // window.open('http://service.weibo.com/share/share.php?url=' + encodeURIComponent(location.href) + '&shareTitle=' + title + '&shareDesc=' + content + '&thumbnail=' + img + '')
        return false
      }

      // qq接口的传参
      if (type === 'qq') {
        this.whichShareBtnSelect = type
        window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + location.href + '&sharesource=qzone&title=' + title + '&pics=' + img + '&summary=' + content + '')
        return false
      }

      // 生成二维码给微信扫描分享
      if (type === 'wx') {
        if (this.whichShareBtnSelect === 'wx') {
          this.whichShareBtnSelect = ''
        } else {
          this.whichShareBtnSelect = type
        }
      }
    },
    doSwiper () {
      this.isDoingSwiper = true
      // window.pano.touchable = false
    },
    swiperChangePano (where) {
      if (where === 'prev') {
        if (this.introPano.panoIndex > 0) {
          this.setPano(this.panoGroup[this.introPano.panoIndex - 1])
        }
      }
      if (where === 'next') {
        if (this.introPano.panoIndex < this.panoGroup.length - 1) {
          this.setPano(this.panoGroup[this.introPano.panoIndex + 1])
        }
      }
    },
    // 播放介绍音频
    playIntroAudio (idName) {
      this.idName = idName
      if (this.infoAudioPlay) {
        document.querySelector('#' + idName).pause()
        if(this.audioTime.interval){
          clearInterval(this.audioTime.interval)
        }
        this.$emit('othersPlayDone')
        this.infoAudioPlay = false
      } else {
        this.audioDomIsPlay = !document.querySelector('#audioDom').paused
        this.$emit('willPlayOthers')
        document.querySelector('#' + idName).play()
        this.audioTime.interval = setInterval(() => {
          if(document.querySelector('#' + this.idName)){
            this.formatTime(parseInt(document.querySelector('#' + this.idName).currentTime), 'play')
          }else{
            clearInterval(this.audioTime.interval)
          }
        }, 1000)
        this.infoAudioPlay = true
      }
    },
    formatTimeNew (idName) {
      document.querySelector('#' + idName).onended = () => {
        this.playIntroAudio(this.idName)
      }
    },
    formatTime (t, type) {
      if (type === 'total') {
        this.audioTime.totalMinutes = t
      }
      if (type === 'play') {
        this.audioTime.playMinutes = t
        this.audioTime.per = (this.audioTime.playMinutes / this.audioTime.totalMinutes) * 100 + '%'
        if (this.audioTime.playMinutes === this.audioTime.totalMinutes) {
          this.playIntroAudio(this.idName)
          document.querySelector('#' + this.idName).currentTime = 0
        }
      }
    },
    getAudioDuration () {
      let audio = document.getElementById(this.idName)
      if (audio) {
        this.formatTime(parseInt(audio.duration), 'total')
      }
    },
    formatAudioTime () {
      let audio = document.getElementById(this.idName)
      if (audio) {
        audio.removeEventListener('canplay', this.getAudioDuration)
        audio.load()
        audio.addEventListener('canplay', this.getAudioDuration)
      }
    },
    changeAudio (idName) {
      this.idName = idName
      this.audioTime.per = 0
      this.$nextTick(() => {
        this.infoAudioPause()
        this.formatAudioTime(idName)
      })
    },
    infoAudioPause () {
      let audio = document.getElementById(this.idName)
      if (this.infoAudioPlay) {
        if (audio) {
          document.querySelector('#' + this.idName).pause()
        }
        this.othersPlayDone()
        // clearInterval(this.audioTime.interval)
        this.infoAudioPlay = false
      }
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }
  $animationTime: 0.6s;
  * {
    outline: none;
    --body-color: #008C8C;
  }
  @font-face{
    font-family: 'SemiBold';
    src: url('../assets/font/SemiBold.otf') format('truetype');
  }

  .logo-box{
    .tuijian{
      width: rem(104) !important;
      right: rem(360) !important;
    }
    span{
      /*background: none !important;*/
    }
  }
  #main-cover-img_text {
    .close-btn {
      top: rem(160);
      right: rem(180);
    }
  }

  @keyframes musicRotate
  {
    0% {
      transform: rotateZ(0);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  #videoSetBox {
    .close-btn {
      top: rem(60);
      right: rem(85);
    }
  }
  .daolan {
    width: rem(180);
    height: rem(40);
    position: absolute;
    top: rem(52);
    /*left: rem(335);*/

    .daolan_bigBtn {
      /*width: rem(214) !important;*/
      height: rem(60);
      position: relative;
      /*margin-right: rem(10);*/
      /*margin-left: rem(40);*/
      cursor: pointer;
      img.acive {
          width: rem(200);
      }

    }
  }

  .btns_left_box {
    position: absolute;
    left: rem(40);
    top: rem(250);
    width: rem(48);
    height: rem(238);
    box-sizing: border-box;
    background: rgba(25, 35, 70, 0.85);
    border-radius: rem(6);
    display: flex;
    flex-direction:column;
    align-content: center;
    align-items: center;

    .btn_full {
      width: rem(24);
      height: rem(24);
      background: url(../assets/img/marker/full_icon.png) no-repeat;
      background-size: rem(24) rem(24);
      margin-top: rem(35);
      margin-bottom: rem(50);

      &:hover {
        background: url(../assets/img/marker/full_icon_hover.png) no-repeat;
        background-size: rem(24) rem(24);
      }
    }

    .btn_share {
      width: rem(24);
      height: rem(24);
      background: url(../assets/img/marker/share_icon.png) no-repeat;
      background-size: rem(24) rem(24);
      margin-bottom: rem(50);

      &:hover {
        background: url(../assets/img/marker/share_icon_hover.png) no-repeat;
        background-size: rem(24) rem(24);
      }
    }

    .btn_musice {
      width: rem(24);
      height: rem(24);

      &.selected{
          .music {
            background: url(../assets/img/marker/musice_icon_hover.png) no-repeat;
            background-size: rem(24) rem(24);
            animation: musicRotate 5s linear infinite;
          }
      }
      .music {
          display: block;
          width: rem(24);
          height: rem(24);
          background: url(../assets/img/marker/musice_icon.png) no-repeat;
          background-size: rem(24) rem(24);
      }

      // &:hover {
      //   background: url(../assets/img/marker/musice_icon_hover.png) no-repeat;
      //   background-size: rem(24) rem(24);
      // }
    }

  }

  .marker-pdf{
    width: rem(82);
    height: rem(86);
    background: url("../assets/img/marker/marker-pdf.png") no-repeat 0 0;
    background-size: 100% 100%;
    transition: transform 0.3s;
    &:hover{
      transform: scale3d(1.2, 1.2, 1);
    }
  }
  .marker-url{
    cursor: pointer;
    width: rem(155);
    height: rem(165);
    background: url("../assets/img/marker/jiche.png") no-repeat 0 0;
    background-size: 100% 100%;
    transition: transform 0.3s;
    &:hover{
      transform: scale3d(1.2, 1.2, 1);
    }
  }

  .pano-change-marker > div{
    cursor: pointer;
    transition: transform 0.3s;
    transform-origin: center center !important;
    &:hover{
      transform: scale3d(1.2, 1.2, 1);
    }
  }

  /*空间切换类marker样式*/
  .movingArrowRight {
    background-image: url('../assets/img/marker/right-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingArrowRightkey infinite steps(27) 1000ms;
    animation: movingArrowRightkey infinite steps(27) 1000ms;
  }

  @keyframes movingArrowRightkey {
    0% {
      background-position: 0 1080px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingArrowDown {
    background-image: url('../assets/img/marker/up-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingArrowDownkey infinite steps(27) 1000ms;
    animation: movingArrowDownkey infinite steps(27) 1000ms;
  }

  @keyframes movingArrowDownkey {
    0% {
      background-position: 0 972px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingArrowLeft {
    background-image: url('../assets/img/marker/left-marker-arrow.png');
    background-position: 0 0;
    background-size: 100% auto;
    -webkit-animation: movingLeftDownkey infinite steps(27) 1000ms;
    animation: movingLeftDownkey infinite steps(27) 1000ms;
  }

  @keyframes movingLeftDownkey {
    0% {
      background-position: 0 1080px;
    }
    100% {
      background-position: 0 0;
    }
  }

  .movingNormal {
    background-image: url('../assets/img/marker/marker-normal.png');
    background-position: 0 0;
    background-size: 100% 100%;
    -webkit-animation: movingNormalkey infinite 1000ms;
    animation: movingNormalkey infinite 1000ms;
  }

  @keyframes movingNormalkey {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(5px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /*marker样式*/
  .marker-line {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0;
    // line-height: 0;
    cursor: pointer;
    transition: transform 0.3s;
    transform-origin: center bottom;
    .title {
      font-size: 14px !important;
      text-align: center;
      line-height: rem(16);
    }
    &.info {
      img {
        margin-left: 34px;
        width: 45px;
        height: 45px;
        border: 1px solid #FFFFFF;
        border-radius: 5px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
    }
    &.big {
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      .title {
        width: 115px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        line-height: 18px;
        color: #FFFFFF;
        letter-spacing: 1.2px;
        text-align: center;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
        margin-bottom: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        margin-left: 34px;
        width: 45px;
        height: 45px;
        border: 2px solid #bc852f;
        border-radius: 50%;
        box-shadow:0px 1px 5px 0px rgba(34,12,2,0.5);
        // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
        background: linear-gradient(150deg, #8A8B8D 0%, #DFDFDF 100%);
      }
      .line {
        width: 1px;
        height: 14px;
        margin-left: 57px;
        background: #E8C68D;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-left: 52.5px;
        background: url('../assets/img/pc/pointer.png');
        background-size: cover;
      }
    }
    &.small {
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      .title {
        width: 69px;
        font-family: PingFangSC-Regular;
        font-size: 10px;
        line-height: 14px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: center;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        margin-left: 20px;
        width: 27px;
        height: 27px;
        border: 1px solid #FFFFFF;
        border-radius: 50%;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
      .line {
        width: 1px;
        height: 8px;
        margin-left: 34px;
        background: #FFFFFF;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
      .circle {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        margin-left: 33px;
        background: #FFFFFF;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
      }
    }
    &.text{
      width: rem(200);
      height: rem(100);
      // border: 2px solid #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      img.textMarker {
        width: rem(58);
        height: rem(65);
        // margin: 0 rem(10) 0 rem(30);
        animation: bigRipple infinite steps(12) 3s;
      }
      img.thumbnail {
        width: rem(55);
        height: rem(55);
        border: 2px solid #bc852f;
        border-radius: 50%;
        box-shadow:0px 1px 5px 0px rgba(34,12,2,0.5);
        // box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
        background: linear-gradient(150deg, #8A8B8D 0%, #DFDFDF 100%);
      }
      p.title {
        line-height: rem(16);
        margin-top: rem(10);
        font-size:rem(14);
        font-weight:600;
        color:rgba(46,46,46,1);
        letter-spacing:0;
      }
    }
    &.video{
      width: rem(82);
      height: rem(86);
      // border: 2px solid #ffffff;
      border-radius: 3px;
      overflow: hidden;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      .btn{
        width: rem(82);
        height: rem(86);
        border-radius: 50%;
        &::after{
          content: ' ';
          width: rem(82);
          height: rem(86);
          position: absolute;
          left: 0;
          top: 0;
          background: url("../assets/img/marker/btn-play.png") no-repeat 0 0;
          background-size: 100% 100%;
        }
      }
    }
    .img-box {
      position: relative;
      margin-left: 34px;
      width: 45px;
      height: 45px;
      img {
        margin: 0;
      }
      .icon {
        position: absolute;
        width: rem(24);
        height: rem(24);
        right: rem(-8);
        top:  rem(-8);
        box-shadow: none;
        margin: 0;
        background: none;
        border: none;
      }
    }
  }

  /*地震局marker样式*/
  .marker-circle{
    width: rem(80);
    height: rem(80);
    cursor: pointer;
    .marker-zhan{
      background: url("../assets/img/marker/quwo/marker.png") center center no-repeat;
      background-size: 100% 100%;
    }
    div{
      /*width: rem(80);*/
      /*height: rem(80);*/
      transition: all $animationTime;
      position: relative;

      font-size: rem(15);
      color: white;
      width: rem(174);
      height: rem(109);
      -webkit-transition: all 0.6s;
      transition: all 0.6s;
      position: relative;
      text-align: center;
      line-height: rem(77);
      &:hover{
        transform: scale3d(1.2,1.2,1);
        &::after{
          content: ' ';
          width: rem(60);
          text-align: center;
          color: #ffffff;
          background: #5F96FF;
          font-size: rem(12);
          line-height: rem(14);
          border-radius: rem(7);
          position: absolute;
          left: 50%;
          top: rem(52);
          margin-left: rem(-30);
        }
      }
    }
    .marker-info{
      background: url("../assets/img/marker/dizhen/marker-info.png") no-repeat 0 0;
      background-size: 100% 100%;
      &:hover{
        &::after{
          content: '分类图文';
        }
      }
    }
    .marker-video{
      background: url("../assets/img/marker/dizhen/marker-video.png") no-repeat 0 0;
      background-size: 100% 100%;
      &:hover{
        &::after{
          content: '视频';
        }
      }
    }
    .marker-audio{
      background: url("../assets/img/marker/dizhen/marker-tiyan.png") no-repeat 0 0;
      background-size: 100% 100%;
      &:hover{
        &::after{
          content: '模拟体验';
        }
      }
    }
    .marker-panoVideo{
      background: url("../assets/img/marker/dizhen/marker-line.png") no-repeat 0 0;
      background-size: 100% 100%;
      &:hover{
        &::after{
          content: '时间线';
        }
      }
    }
    .marker-threeDModel{
      background: url("../assets/img/marker/dizhen/marker-3d.png") no-repeat 0 0;
      background-size: 100% 100%;
      &:hover{
        &::after{
          content: '三维模型';
        }
      }
    }
  }
  .marker-circle-link{
    width: rem(656/2);
    height: rem(720/2);
    cursor: pointer;
    img{
      width: rem(656/2);
      height: rem(720/2);
    }
  }

  /*界面样式*/
  .card-cover{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(4,20,32,0.6);
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .close-btn{
      width: rem(55);
      height: rem(55);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
    .title{
      width: rem(250);
      height: rem(48);
      background: url("../assets/img/mobile/main-logo.png") no-repeat 0 0;
      background-size: rem(250) rem(48);
      position: absolute;
      left: rem(50);
      top: rem(40);
    }
    .timeline{
      height: rem(48);
      position: absolute;
      left: 50%;
      bottom: rem(80);
      transform: translateX(-50%);
      li{
        float: left;
        margin-right: rem(120);
        width: rem(10);
        height: rem(10);
        position: relative;
        &:nth-last-of-type(1){
          margin-right: 0;
        }
        &::before{
          content: ' ';
          width: rem(8);
          height: rem(8);
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 50%;
          border: 1px solid #ffffff;
        }
        &::after{
          content: ' ';
          width: rem(120);
          height: 0;
          border-bottom: 1px dotted #ffffff;
          position: absolute;
          left: rem(10);
          top: rem(4);
        }
        &:nth-last-of-type(1):after{
          display: none;
        }
      }
      p{
        font-family: PingFangSC-Regular;
        font-size: rem(17);
        line-height: rem(24);
        color: #FFFFFF;
        letter-spacing: rem(1);
        text-align: justify;
        position: absolute;
        left: 50%;
        top: rem(24);
        transform: translateX(-50%);
        white-space: nowrap;
      }
    }
  }
  .main-cover{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 11;
    &#videoBox {
      z-index: 999 !important;
    }
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .box{
      width: 100vw;
      height: 100vh;
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // margin-left: rem(-622);
      // margin-top: rem(-350);
      font-size: 0;
    }
    .video-box{
      z-index: 999;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-content: center;
      justify-content: center;
      align-items: center;
      video{
        width:rem(1000);
        height: rem(560);
        background: #000000;
      }
    }
    img.exitPlay {
      width: rem(208);
      height: rem(66);
      position: absolute;
      bottom: rem(45);
      left: 50%;
      margin-left: rem(-104);
      cursor: pointer;
    }
    .singleImg-box{
      width: 100vw;
      height: 100vh;
      position: relative;
      img{
        background: #000000;
        position: absolute;
        top:50%;
        left:50%;
        max-height:100%;
        max-width:100%;
        transform:translate(-50%, -50%);
      }
    }
    .box-image-swiper{
      width: rem(1200);
      height: rem(1800);
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: rem(-600);
      margin-top: rem(-500);
      font-size: 0;
    }
    .image-swiper-box{
      width: rem(1200);
      height: rem(800);
      img{
        width: rem(1200);
        height: rem(800);
      }
      .swiper-button-prev {
        width: rem(55);
        height: rem(55);
        background: url("../assets/img/pc/icon-expand.png") no-repeat 0 0;
        background-size: rem(55) rem(55);
        cursor: pointer;
        z-index: 100;
        transform: rotateZ(180deg);
        &:hover {
          background: url("../assets/img/pc/icon-expand-hover.png") no-repeat 0 0;
          background-size: rem(55) rem(55);
        }
      }
      .swiper-button-next{
        width: rem(55);
        height: rem(55);
        background: url("../assets/img/pc/icon-expand.png") no-repeat 0 0;
        background-size: rem(55) rem(55);
        cursor: pointer;
        z-index: 100;
        &:hover {
          background: url("../assets/img/pc/icon-expand-hover.png") no-repeat 0 0;
          background-size: rem(55) rem(55);
        }
      }
      .swiper-pagination-bullet-active{
        background: #FCD187;
      }
    }
    .iframe-box{
      width: 100vw;
      height: 100vh;
      iframe{
        background: #ffffff;
        width: 100vw;
        height: 100vh;
      }
      &.pdf-box{
        margin: rem(120) auto 0;
        width: rem(960);
        height: rem(570);
        overflow-y: scroll;
        -webkit-overflow-scrolling:touch;
      }
    }
    .close-btn{
      width: rem(25);
      height: rem(25);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
      background-size: rem(25) rem(25);
      position: fixed;
      right: rem(30);
      top: rem(30);
      cursor: pointer;
      z-index: 11;
    }
  }
  .textMarker-cover {
    .area {
      width: 100%;
      height: rem(1000);
      position: fixed;
      .card-pad{
        margin: rem(10) rem(20) rem(10) 0;
        transition: transform 0.2s;
        &:nth-of-type(1){
          // padding-left: rem(50);
          margin-left: rem(50);
        }
        &:nth-last-of-type(1){
          margin-right: rem(50);
        }
      }
      .card-intro{
        width: rem(400);
        height: rem(570);
        position: relative;
        margin-top: rem(150);
        cursor: pointer;
        box-shadow: 0px rem(12) rem(12) 0px rgba(30, 46, 79, 0.5);
        border-radius: rem(12);
        border: 1px solid #FFE1BE;
        box-sizing: border-box;
        overflow: hidden;
        .background{
          width: rem(400);
          height: rem(570);
          position: absolute;
          left: 0;
          top: 0;
          border-radius: rem(12);
          background: rgba(25, 35, 70, 0.85);
        }
      .text{
          width: rem(362);
          height: rem(570);
          margin: auto;
          position: absolute;
          left: 0;
          right: 0;
          padding-left: rem(38);
          margin-right: rem(38);
          z-index: 9;
          box-sizing: border-box;
        }
        .title {
          // width: 6.25rem;
          margin-top: rem(40);
          height: rem(65);
          font-size: rem(24);
          line-height: rem(25);
          font-weight: 300;
          color: #FFE1BE;
          // line-height: 2rem;
          letter-spacing: 2px;
          padding: 0 rem(15);
          text-align: left;
        }
        .intro-box {
          height: rem(455);
        }
        .intro {
          font-family: PingFangSC-Regular;
          font-size: rem(12)!important;
          line-height: .775rem!important;
          color: #fff;
          /*letter-spacing: rem(3);*/
          text-align: justify;
          text-indent: .65rem;
          padding: 0 rem(15) 0;
          * {
            font-size: rem(12)!important;
          }
          img {
            display: block;
            width: 100%!important;
          }
        }
      }
      /*& .card-intro:nth-child(3) .intro{*/
        /*letter-spacing:0px*/
      /*}*/

      /*& .card-intro:nth-child(5) .intro{*/
        /*letter-spacing:0px*/
      /*}*/

    }
    .close-btn{
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/pc/icon-close.png") no-repeat;
      background-size: rem(24) rem(24);
      position: fixed;
      right: rem(60);
      top: rem(40);
      cursor: pointer;
      z-index: 11;
      font-size: rem(40);
    }
  }
  .textMarker-cover-one{
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;
    font-size: 0;
    border-radius: rem(5);
    overflow: hidden;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .area{
      left: 50%;
      top: 50%;
      position: absolute;
      width: rem(1140);
      height: rem(778);
      transform: translate(-50%, -50%);
      background-size: 100% 100%;
    }
    .box{
      width: rem(1000);
      height: auto;
      margin-left: rem(170);
      margin-bottom: rem(50);
    }
    .card-pad{
      width: rem(1000)!important;
      margin: 0 auto 0 auto!important;
      &:hover{
      transform: scale3d(1, 1, 1)!important;
      z-index: 999;
        }
    }
    .text {
      width: rem(1200)!important;
    }
    .intro{
      width: rem(1000)!important;
      li{
        margin-bottom: rem(30);
        padding: 0 rem(20);
      }
      img {
        width: 100%!important;
      }
    }
    .official-web-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      left: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-official-web.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .contact-us-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      right: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-contact-us.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .close-btn{
      background-size: rem(50) rem(50);
      position: fixed;
      cursor: pointer;
      z-index: 1;
    }
    .swiper-scrollbar{
      right: 3px!important;
      left: auto!important;
      background: rgba(0, 0, 0, 0);
    }
    .swiper-scrollbar-drag{
      background: #F2F2F2;
    }
  }
  .top-cover {
    height: rem(130);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    background-image: linear-gradient(180deg, #182848 0%, rgba(24,40,72,0.46) 74%, rgba(24,40,72,0.00) 100%);

    /*background: linear-gradient(to bottom, rgba(8, 17, 39, 0.70) 0%, rgba(8, 17, 39, 0.51) 27%, rgba(8, 17, 39, 0.28) 49%, rgba(16, 28, 59, 0.13) 70%, rgba(20, 35, 71, 0.03) 83%, rgba(25, 42, 82, 0.00) 100%);*/
    /*opacity: 0.4;*/
    transform: translateY(0);
    /*background: url("../assets/img/pc/cover-top.png") no-repeat 0 0;*/
    /*background-size: 100% 100%;*/
    /*background: linear-gradient(to bottom, rgba(56,8,0,0.82) 0%, rgba(56,8,0,0) 100%);*/
    /*transform: translateY(0);*/
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(-100));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }
  .bottom-cover {
    height: rem(100);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(8, 17, 39, 0.70) 0%, rgba(8, 17, 39, 0.51) 27%, rgba(8, 17, 39, 0.28) 49%, rgba(16, 28, 59, 0.13) 70%, rgba(20, 35, 71, 0.03) 83%, rgba(25, 42, 82, 0.00) 100%);
    opacity: 0.6;
    transform: translateY(0);
    /*background: url("../assets/img/pc/cover-bottom.png") no-repeat 0 0;*/
    /*background-size: 100% 100%;*/
    /*background: linear-gradient(to bottom, rgba(56,8,0,0.00) 0%, rgba(56,8,0,0.82) 100%);;*/
    /*transform: translateY(0);*/
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(100));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }
  .right-cover {
    width: rem(330);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    /*background: url("../assets/img/pc/cover-right.png") no-repeat 0 0;*/
    /*background-size: 100% 100%;*/
    /*transform: translateX(rem(330));*/
    /*<!--transition: transform $animationTime;-->*/
    &.opacity-enter, &.opacity-leave-to {
      opacity: 0;
    }
    &.opacity-enter-active, &.opacity-leave-active {
      transition: opacity $animationTime;
    }
    &.show{
      transform: translateX(0);
      .list-box{
        .button{
          background: url("../assets/img/pc/list-card-right-btn.png") no-repeat 0 0;
          background-size: 100% 100%;
          &:hover{
            background: url("../assets/img/pc/list-card-right-btn-hover.png") no-repeat 0 0;
            background-size: 100% 100%;
          }
        }
      }
    }
    /*background: linear-gradient(to right, rgba(56,8,0,0.00) 0%, rgba(56,8,0,0.82) 100%);;*/
    /*&.moveIn-enter, &.moveIn-leave-to {*/
      /*!*transform: opacify();*!*/
    /*}*/
    /*&.moveIn-enter-active, &.moveIn-leave-active {*/
      /*<!--transition: transform $animationTime;-->*/
    /*}*/
    .list-box{
      position: absolute;
      top: rem(50);
      right: rem(-2);
      bottom: rem(50);
      width: rem(330);
      border-left: 4px solid #5F96FF;
      height: rem(500);
      .list-area{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(180deg, rgba(55, 80, 150, 0.72) 0%, rgba(25, 35, 70, 0.9) 100%);
        h2{
          /*width: 100%;*/
          /*height: rem(95);*/
          font-size: rem(14);
          /*line-height: rem(95);*/
          /*text-indent: rem(30);*/
          padding-left: rem(35);
          padding-right: rem(30);
          color: #FFE1BE;
          font-weight: 300;
          /*line-height: rem(14);*/
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          padding-top: rem(29);
          span {
            /*display: inline-block;*/
            font-size: rem(12);
            font-weight: 500;
            color: #FFE1BE;
            margin-right: rem(24);
            position: relative;
            /*text-indent: rem(35);*/
            padding-left: rem(32);
          }
          .curradrr{
            display: block;
            padding-left:rem(0);
            margin-right: 0;
            font-size: rem(12);
            font-family: STHeitiSC-Light, STHeitiSC;
            font-weight: 300;
            color: #018B8D;
            line-height: 14px;
            margin-top: rem(12);
            text-shadow: 0px rem(2) rem(4) rgba(0, 0, 0, 0.5);
          }

          .daohang_icon {
            display: inline-block;
            width: rem(32);
            height: rem(32);
            background: url("../assets/img/marker/menu_icon.png") no-repeat center center;
            background-size: rem(32) rem(32);
            position: absolute;
            left: 0;
            /*top: rem(30);*/
          }
        }
        .list-map-box{
          position: absolute;
          width: rem(255);
          height: rem(144);
          /*margin: auto;*/
          left: rem(35);
          top: rem(68);
          font-size: 0;
          /*background: #385492;*/
          background: #D8D8D8;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5), 0px 5px 12px 0px rgba(0, 0, 0, 0.12);
          border-radius: 8px;
          .list-map{
            width: 100%;
            height: rem(184)
          }
          .map-hover-box{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            .map-hover:nth-of-type(1){
              width: rem(30);
              height: rem(33);
              position: absolute;
              left: rem(15);
              bottom: rem(2);
              opacity: 0;
            }
            .map-hover:nth-of-type(2){
              width: rem(143);
              height: rem(128);
              position: absolute;
              left: rem(25);
              top: rem(6);
              opacity: 0;
            }
            .map-hover:nth-of-type(3){
              width: rem(99);
              height: rem(125);
              position: absolute;
              left: rem(159);
              top: rem(6);
              opacity: 0;
            }
            .map-hover:nth-of-type(4){
              width: rem(164);
              height: rem(120);
              position: absolute;
              left: rem(97);
              top: rem(30);
              opacity: 0;
            }
            .map-hover:nth-of-type(5){
              /*width: rem(109);*/
              /*height: rem(48);*/
              position: absolute;
              left: rem(319);
              top: rem(6);
              opacity: 0;
            }
            .map-hover:nth-of-type(6){
              width: rem(100);
              height: rem(80);
              position: absolute;
              left: rem(340);
              top: rem(65);
              opacity: 0;
            }
            .map-hover:nth-of-type(7){
              width: rem(40);
              height: rem(80);
              position: absolute;
              left: rem(309);
              top: rem(102);
              opacity: 0;
            }
            .map-hover:nth-of-type(8){
              width: rem(73);
              height: rem(8);
              position: absolute;
              left: rem(350);
              top: rem(169);
              opacity: 0;
            }
            .map-hover:nth-of-type(9){
              width: rem(81);
              height: rem(24);
              position: absolute;
              left: rem(360);
              bottom: rem(0);
              opacity: 0;
            }
            .show{
              opacity: 1 !important;
            }
            .hover{
              animation: twinkle 1.5s infinite linear !important;
            }
          }
          .list-marker-box{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: url("../assets/img/pc/fushitu.png") center center no-repeat;
            background-size: 100% 100%;

            .marker-btn{
              position: absolute;
              width: rem(20);
              height: rem(34);
              background: url("../assets/img/pc/meidian.png") no-repeat 0 0;
              background-size: 100% 100%;
              transform: translate3d(rem(-20), rem(-34), 0);
              cursor: pointer;

              &.jump{
                animation: markerBtnJump 1.5s infinite linear;
              }
              &.selected, &:hover{
                &.jump{
                  animation: markerBtnJump 1.5s infinite linear;
                }
                .num{
                  width: rem(16);
                  height: rem(16);
                  margin-top: rem(-14);
                  margin-left: rem(-8);
                  font-size: rem(10);
                  line-height: rem(16);
                  /*background: #FF5E64;*/
                }
              }
              .num{
                display: block;
                width: rem(16);
                height: rem(16);
                position: absolute;
                left: 50%;
                top: 50%;
                margin-top: rem(-14);
                margin-left: rem(-8);
                /*background: #5F96FF;*/
                border-radius: 50%;
                font-size: rem(10);
                text-align: center;
                line-height: rem(16);
                color: #ffffff;
              }
            }
            .selected{
              background: url("../assets/img/pc/dian.png") no-repeat 0 0;
              background-size: 100% 100%;
            }
          }
        }
        .list{
          width: 100%;
          h3{
            width: 100%;
            height: rem(39);
            font-size: rem(18);
            line-height: rem(39);
            text-indent: rem(47);
            color: rgba(253,223,142,1);
          }
          ul{
            position: absolute;
            left: rem(35);
            right: rem(20);
            top: rem(220);
            bottom: 0;
            padding-top: rem(10);
            overflow-y: auto;
            -webkit-overflow-scrolling:touch;
            li{
              position: relative;
              width: rem(210);
              height: rem(26);
              line-height: rem(26);
              border-radius: rem(3);
              padding-left: rem(27);
              margin-bottom: rem(10);
              display: flex;
              cursor: pointer;
              &::before{

              }
              &.selected::after{
                content: ' ';
                position: absolute;
                right: rem(13);
                top: rem(9);
                width: rem(6);
                height: rem(6);
                line-height: rem(26);
                border-radius: 50%;
                /*border: 1px solid #FFFFFF;*/
                background-color: #FFFFFF;
              }
              &.selected,&:hover{
                /*background: #008C8C;*/
                background: var(--body-color);
                /*box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5), 0px 2px 4px 0px rgba(39, 56, 94, 0.55), 0px 2px 1px 0px rgba(132, 179, 255, 0.45);*/
                border-radius: rem(4);
                 &::before{
                   background: #ffffff;
                 }
                p{
                  font-size: rem(16);
                  line-height: rem(26);
                  height: inherit;
                  color: #ffffff;
                }
                span{
                  color: #ffffff;
                  border: 1px solid #ffffff;
                  background:linear-gradient(191deg,rgba(231,198,140,1) 0%,rgba(222,181,114,1) 49%,rgba(188,133,47,1) 100%);
                }
              }
              p{
                /*text-indent: rem(33);*/
                font-size: rem(16);
                line-height: rem(26);
                height: inherit;
                color: #018B8D;
              }
              span{
                display: inline-block;
                width: rem(46);
                height: rem(46);
                font-size: rem(19);
                color: #ffffff;
                line-height: rem(46);
              }
            }
          }
        }
      }
      .list-cover{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: rem(114);
        background: url("../assets/img/pc/list-card-small-background.png") no-repeat 0 0;
        background-size: 100% 100%;
        .list-cover-tip{
          font-size: rem(18);
          line-height: rem(25);
          color: #FDDF8E;
          width: rem(18);
          position: absolute;
          left: rem(10);
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .button{
        width: rem(20);
        height: rem(88);
        position: absolute;
        left: rem(-20);
        top: 50%;
        margin-top: rem(-44);
        background: url("../assets/img/pc/list-card-left-btn.png") no-repeat 0 0;
        background-size: 100% 100%;
        cursor: pointer;
        &:hover{
          background: url("../assets/img/pc/list-card-left-btn-hover.png") no-repeat 0 0;
          background-size: 100% 100%;
        }
      }
    }
  }
  .right-cover{
    left: 2rem !important;
    top: 1rem !important;
    .list-box{
      .sanjiao{
        display: inline-block;
        position: absolute;
        top:rem(-9);
        left:50%;
        width: 0;
        height: 0;
        border-left: rem(10) solid transparent;
        border-right: rem(10) solid transparent;
        border-bottom: rem(10) solid rgba(255,255,255,.89);
      }
    }
    .button{
      display: none !important;
    }
    .list-box{
      border-left: none;
      .list-area{
        background: rgba(255,255,255,.89) !important;
      }
    }
  }
  .logo-box {
    position: absolute;
    left: rem(0);
    top: rem(0);
    width: 100%;
    height: rem(75);
    line-height: rem(75);
    background: rgba(255, 255, 255, 0.85);
    box-shadow: 0px 5px 4px 0px rgba(0, 0, 0, 0.12);
    transform: translateY(0);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(-130));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .littleicon{
      position: absolute;
      right: rem(45);
      top: rem(26);
      span{
        display: inline-block;
        cursor: pointer;
        width: rem(22);
        height: rem(22);
        margin-right: rem(16);
      }
      span:last-child{
        margin-right: 0;
      }
      .music{
        background-image: url("../assets/img/pc/music.png");
        background-size: cover;
      }
      .musicActive{
        background-image: url("../assets/img/pc/musichover.png") !important;
        background-size: cover;
      }
      .share{
        background-image: url("../assets/img/pc/share.png");
        background-size: cover;
      }
      .shareActive{
        background-image: url("../assets/img/pc/sharebtn.png");
        background-size: cover;
      }
      .full{
        background-image: url("../assets/img/pc/fangda.png") ;
        background-size: cover;
      }
      .fangdaActive{
        background-image: url("../assets/img/pc/fangdahover.png") ;
        background-size: cover;
      }
    }
    .daolan{
        /*margin-left: 64%;*/
      margin-left: rem(800);
      /*right: rem(166);*/
        right:rem(185);
        top:0;
        margin-top: rem(18);
        .daolan_bigBtn{
          span{
            cursor: pointer;
            display: inline-block;
            /*width: rem(68);*/
            font-size: rem(16);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(1, 139, 141, 0.4);
            line-height: rem(40);
            letter-spacing: 1px;
            padding-bottom: rem(0);
            margin-right: rem(25);
            margin-left: 0;
          }
          span:nth-child(2){
            margin-right: 0;
          }
          .active{
            color: #018B8D;
            border-bottom: 3px solid #018B8D;


          }
        }
    }
    .addr{
      span{
        cursor: pointer;
        display: inline-block;
        width: rem(24);
        height: rem(24);
        background: url("../assets/img/pc/addr.png") center center no-repeat;
        background-size: 100% 100%;
        margin-left: rem(47);
        margin-top: rem(24);
      }
      .addhover{
        background: url("../assets/img/pc/addrhover.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    .logo {
      float: left;
      margin-left: rem(30);
      margin-top: rem(15);
      width: rem(170);
      height: rem(45);
      background: url("../assets/img/pc/logo.png") no-repeat 0 0;
      background-size: 100% 100%;
    }
    .back {
      float: left;
      width: rem(94);
      height: rem(44);
      background: url("../assets/img/pc/icon-back.png") no-repeat 0 0;
      background-size: rem(94) rem(44);
      cursor: pointer;
      &:hover{
        background: url("../assets/img/pc/icon-back-hover.png") no-repeat 0 0;
        background-size: rem(94) rem(44);
      }
    }
    span {
      float: left;
      display: block;
      /*width: 1px;*/
      height: rem(40);
      background: url("../assets/img/mobile/logo-line.png") no-repeat center center;
      background-size: 1px rem(40);
      margin-left: rem(12);
    }
    .visit-num{
      float: left;
      font-family: PingFangSC-Regular;
      font-size: rem(18);
      line-height: rem(40);
      color: #FFFFFF;
      letter-spacing: rem(1);
      margin-left: rem(46);
      position: relative;
      &::before{
        content: ' ';
        display: block;
        width: rem(22);
        height: rem(16);
        position: absolute;
        top: rem(12);
        left: rem(-28);
        background: url("../assets/img/mobile/icon-visit-color.png") no-repeat 0 0;
        background-size: rem(22) rem(16);
      }
    }
    .name{
      float: left;
      font-family: PingFangSC-Regular;
      font-size: rem(16);
      line-height: rem(24);
      color: #FFFFFF;
      letter-spacing: rem(1);
      text-shadow: 0 2px 4px rgba(4,20,32,0.30);
      margin-left: rem(20);
      margin-top: rem(10);
    }
  }
   .map-box {
      width: rem(50);
      height: rem(50);
      position: absolute;
      right: rem(40);
      bottom: rem(50);
      transform: translateX(0);
      &.moveIn-enter, &.moveIn-leave-to {
        transform: translateX(rem(100));
      }
      &.moveIn-enter-active, &.moveIn-leave-active {
        transition: transform $animationTime;
      }
     .map-circle{
       width: rem(50);
       height: rem(50);
       transform: rotateZ(0);
     }
    }
  .honor-btn{
    width: rem(46);
    height: rem(50);
    position: absolute;
    left: rem(26);
    top: rem(140);
    background: url("../assets/img/mobile/icon-honor-btn.png") no-repeat 0 0;
    background-size: rem(46) rem(50);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(-72));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }

  .bottom-btn-box {
    position: absolute;
    left: rem(50);
    bottom: rem(48);
    z-index: 12;
    img.tipsbox {
      width: 400px;
      position: absolute;
      top: -400px;
      left: 90px;
    }
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateY(rem(90));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
    .btn-box {
      float: left;
      height: rem(40);
      .bigBtn {
        width: rem(200) !important;
        height: rem(40);
        position: relative;
        margin-right: rem(10);
        cursor: pointer;
        img.musiceIcon {
          width: rem(200);
        }
        img.acive {
          width: rem(200);
        }
      }
      .btn {
        width: rem(40);
        height: rem(40);
        margin-right: rem(15);
        position: relative;
        cursor: pointer;
        .num{
          font-family: PingFangSC-Regular;
          font-size: rem(11);
          line-height: rem(14);
          color: #FFFFFF;
          text-align: center;
          width: 100%;
          position: absolute;
          left: 0;
          bottom: rem(-15);
        }
        .yellowText {
          color: #f2cf90;;
        }
        .icon {
          display: block;
          width: rem(40);
          height: rem(40);
          &.album {
            background: url("../assets/img/pc/icon-album.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.fullscreen {
            background: url("../assets/img/pc/icon-fullscreen.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.like {
            background: url("../assets/img/pc/icon-like.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.share {
            background: url("../assets/img/pc/icon-share.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.music {
            background: url("../assets/img/pc/icon-music.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.info {
            background: url("../assets/img/pc/icon-info.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          &.comment {
            background: url("../assets/img/pc/icon-comment.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
        }
        &:hover, &.selected {
          .album {
            background: url("../assets/img/pc/icon-album-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .fullscreen {
            background: url("../assets/img/pc/icon-fullscreen-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .like {
            background: url("../assets/img/pc/icon-like-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .share {
            background: url("../assets/img/pc/icon-share-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .music {
            background: url("../assets/img/pc/icon-music-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .info {
            background: url("../assets/img/pc/icon-info-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
          .comment {
            background: url("../assets/img/pc/icon-comment-color.png") no-repeat center center;
            background-size: rem(40) rem(40);
          }
        }
        &.selected{
          .music {
            animation: musicRotate 5s linear infinite;
          }
        }
        &:hover {
          .tip {
            display: block;
          }
        }
        .tip {
          display: none;
          padding: 0 rem(12);
          font-family: PingFangSC-Regular;
          font-size: rem(12);
          line-height: rem(26);
          color: #FFFFFF;
          letter-spacing: 1px;
          text-align: center;
          background: rgba(4, 20, 32, 0.7);
          border-radius: rem(4);
          position: absolute;
          left: 50%;
          top: rem(-34);
          transform: translateX(-50%);
          white-space: nowrap;
          &::before {
            content: ' ';
            display: block;
            width: 0;
            height: 0;
            border-width: rem(8) rem(6) 0;
            border-style: solid;
            border-color: rgba(4, 20, 32, 0.7) transparent transparent;
            position: absolute;
            left: 50%;
            bottom: rem(-8);
            transform: translateX(-50%);
          }
        }
      }
    }
    .only-one-btn{
      padding: 0;
      margin-left: rem(30);
    }
  }

  .share-box{
    width: rem(240);
    position: absolute;
    /*left: rem(80);*/
    right: rem(6);
    top: rem(88);
    // bottom: rem(260);
    &.opacity-enter, &.opacity-leave-to {
      opacity: 0;
    }
    &.opacity-enter-active, &.opacity-leave-active {
      transition: opacity $animationTime;
    }
    .qrcode-box{
      width: rem(240);
      height: rem(244);
      background: rgba(255, 255, 255, 0.89);
      border-radius: rem(4);
      text-align: center;
      .share-wx{
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: rem(15);
        line-height: rem(20);
        color: #FFFFFF;
        letter-spacing: rem(3);
        padding-top: rem(18);
        margin-bottom: rem(21);
      }
      .qrcode{
        margin-top: rem(20);
        display: inline-block;
        width: rem(116);
        height: rem(116);
        background: rgba(255,255,255,0.28);
        border-radius: rem(4);
        position: relative;
        margin-bottom: rem(20);
        canvas{
          width: rem(100);
          height: rem(100);
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
      }
      .share-tip{
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: rem(12);
        line-height: rem(18);
        /*color: #008C8C;*/
        color: var(--body-color);
        letter-spacing: rem(1.4);
      }
    }
    .share-btn-box{
      width: rem(240);
      height: rem(74);
      background: rgba(255, 255, 255, 0.89);
      border-radius: rem(4);
      padding-top: rem(18);
      margin-bottom: rem(12);
      &::before {
        content: ' ';
        display: block;
        width: 0;
        height: 0;
        border-width: rem(8) rem(6) 0;
        border-style: solid;
        border-color: rgba(25, 35, 70, 0.8) transparent transparent;
        position: absolute;
        left: rem(-10);
        top: rem(43);
        transform: rotateZ(90deg);
      }
      .share-btn{
        float: left;
        width: rem(40);
        height: rem(62);
        margin: 0 rem(16);
        &:nth-of-type(1){
          margin-left: rem(24);
        }
        div{
          width: rem(40);
          height: rem(40);
          margin-bottom: rem(6);
        }
        p{
          font-family: PingFangSC-Regular;
          font-size: rem(11);
          line-height: rem(16);
          /*color: #008C8C;*/
          color: var(--body-color);
          letter-spacing: rem(1.8);
          text-align: center;
        }
        .wx{
          background: url("../assets/img/pc/wx-icon.png") center center no-repeat;
          background-size: rem(20) rem(20);
        }
        .qq{
          background: url("../assets/img/pc/qq-icon.png")  center center no-repeat;
          background-size: rem(20) rem(20);
        }
        .wb{
          background: url("../assets/img/pc/wb-icon.png")  center center no-repeat;
          background-size: rem(20) rem(20);

        }
        &:hover{
          .wx{
            background: url("../assets/img/pc/wxhover.png")  center center no-repeat;
            background-size: rem(20) rem(20);
          }
          .qq{
            background: url("../assets/img/pc/qqhover.png")  center center no-repeat;
            background-size: rem(20) rem(20);
          }
          .wb{
            background: url("../assets/img/pc/weibohover.png")  center center no-repeat;
            background-size: rem(20) rem(20);
          }
        }
        &.selected{
          .wx{
            background: url("../assets/img/pc/wxhover.png")  center center no-repeat ;
            background-size: rem(20) rem(20);
          }
          .qq{
            background: url("../assets/img/pc/qqhover.png")  center center no-repeat ;
            background-size: rem(20) rem(20);
          }
          .wb{
            background: url("../assets/img/pc/weibohover.png")  center center no-repeat;
            background-size: rem(20) rem(20);
          }
        }
      }
    }
    .sanjiao{
      display: inline-block;
      position: absolute;
      top:rem(-9);
      left:50%;
      width: 0;
      height: 0;
      border-left: rem(10) solid transparent;
      border-right: rem(10) solid transparent;
      border-bottom: rem(10) solid rgba(255,255,255,.89);
    }
  }

  .pano-list-area{
    position: absolute;
    top: rem(50);
    bottom: rem(50);
    right: rem(395);
    width: rem(100);
    z-index: 1;
    transform: translateX(rem(475));
    transition: transform $animationTime;
    &.show{
      transform: translateX(0);
    }
    &.pano-change{
      transform: translateX(rem(385));
    }
    .show-all-background{
      width: 100%;
      height: rem(110);
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .swiper-box{
    position: absolute;
    top: rem(80);
    left: 0;
    width: rem(100);
  }
  .autoplay-btn{
    width: rem(40);
    height: rem(40);
    background: url("../assets/img/mobile/roaming-play.png") no-repeat 0 0;
    background-size: rem(40) rem(40);
    border-radius: 50%;
    // position: absolute;
    // left: rem(20);
    // top: 0;
    cursor: pointer;
    &.pause{
      background: url("../assets/img/mobile/roaming-pause.png") no-repeat 0 0;
      background-size: rem(40) rem(40);
    }
  }
  .pause .autoplay-btn{
      cursor: pointer;
      background: url("../assets/img/mobile/roaming-pause.png") no-repeat 0 0;
      background-size: rem(40) rem(40);
  }
  .pano-list-box{
    width: rem(100);
    position: relative;
    ul{
      /*padding-top: rem(15);*/
      /*padding-left: rem(11);*/
      li{
        margin-left: rem(20);
        width: rem(60);
        height: rem(60);
        position: relative;
        margin-top: rem(10);
        margin-bottom: rem(10);
        cursor: pointer;
      }
    }
    .img-box{
      position: absolute;
      left: 0;
      top: 0;
      width: rem(60);
      height: rem(60);
      transition: transform 0.3s;
      font-size: 0;
      &:hover{
        transform: scale3d(1.1, 1.1, 1);
      }
      &.selected{
        transform: scale3d(1.1, 1.1, 1);
        .btn-title{
          display: block;
        }
        .border{
          background: rgba(0,0,0,0.7);
          border: 2px solid #FCD187;
        }
      }
    }
    img{
      width: rem(60);
      height: rem(60);
      border-radius: 50%;
    }
    .btn-title{
      display: none;
      font-family: SemiBold;
      width: rem(60);
      line-height: 16px;
      font-size: 12px;
      text-align: center;
      color: #FCD187;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }
    .border{
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      width: rem(60);
      height: rem(60);
      border-radius: 50%;
      border: 2px solid #ffffff;
    }
    .selected-btn{
      width: rem(22);
      height: rem(7);
      background: url("../assets/img/mobile/icon-list-focus.png") no-repeat 0 0;
      background-size: rem(22) rem(7);
      position: absolute;
      left: 50%;
      top: rem(-14);
      transform: translateX(-50%);
    }
    .progress-box{
      width: rem(40);
      height: 2px;
      border-radius: 1px;
      background: rgba(255,255,255,0.3);
      position: absolute;
      left: 50%;
      bottom: rem(-10);
      transform: translateX(-50%);
      overflow: hidden;
      .line{
        width: 0;
        height: 100%;
        background: #FCD187;
        transition-property: width;
        transition-timing-function: linear;
      }
    }
  }
  .pano-intro-card{
    position: absolute;
    bottom: rem(94);
    left: 0;
    width: 100%;
    height: rem(90);
    z-index: 6;
    &.fullscreen{
      top: rem(22);
    }
    &.opacity-enter, &.opacity-leave-to {
      opacity: 0;
    }
    &.opacity-enter-active, &.opacity-leave-active {
      transition: opacity $animationTime;
    }
    .card-background{
      position: absolute;
      left: rem(26);
      right: rem(26);
      top: 0;
      bottom: 0;
      transform: translateY(0);

      .title-box{
        position: relative;
        display: inline-block;
        height: rem(40);
        max-width: rem(264);
      }
      h2{
        font-family: SemiBold;
        font-size: rem(18);
        color: #FBE58D;
        letter-spacing: rem(1.5);
        height: rem(26);
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      h3{
        font-family: SemiBold;
        font-size: rem(10);
        color: #FBE58D;
        letter-spacing: rem(1);
        height: rem(14);
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      .audio-btn{
        width: rem(30);
        height: rem(30);
        position: absolute;
        right: rem(-40);
        top: rem(5);
        overflow: hidden;
        img{
          width: rem(90);
          height: rem(30);
          transform: translateX(rem(-60));
        }
        .playing{
          animation: audioPlaying 1.5s forwards steps(3) infinite;
        }
      }
      p{
        width: 100%;
        height: rem(42);
        font-size: rem(12);
        color: #FFFFFF;
        letter-spacing: rem(1);
        line-height: rem(22);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .updown-btn{
        display: block;
        width: rem(30);
        height: rem(30);
        position: absolute;
        right: 0;
        top: rem(5);
        background: url("../assets/img/mobile/icon-down.png") no-repeat center center;
        background-size: rem(15) rem(15);
        transform: rotateZ(180deg);
      }
    }
  }
  .brand-btn{
    width: rem(54);
    height: rem(39);
    position: absolute;
    right: 0;
    bottom: rem(194);
    background: url("../assets/img/mobile/logo-btn.png") no-repeat 0 0;
    background-size: rem(54) rem(39);
    &.moveIn-enter, &.moveIn-leave-to {
      transform: translateX(rem(54));
    }
    &.moveIn-enter-active, &.moveIn-leave-active {
      transition: transform $animationTime;
    }
  }

  /*公司简介样式*/
  .brand-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(21,0,0,0.8);
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .logo{
      width: rem(47);
      height: rem(47);
      position: absolute;
      left: 50%;
      top: rem(55);
      background: url("../assets/img/mobile/brand-logo.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      transform: translateX(-50%);
    }
    .intro{
      width: rem(312);
      position: absolute;
      left: 50%;
      top: rem(124);
      transform: translateX(-50%);
      border-top: 1px solid rgba(255,255,255,0.5);
      p{
        font-family: PingFangSC-Light;
        font-size: rem(14);
        color: #ffffff;
        letter-spacing: rem(1);
        line-height: rem(24);
      }
    }
    .official-web-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      left: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-official-web.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .contact-us-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      right: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-contact-us.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .close-btn{
      width: rem(47);
      height: rem(47);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
  }

  @keyframes bigRipple {
    0% {
        opacity: 1;
        -webkit-transform: scale(0.8);
                transform: scale(0.8)
    }
    50% {
        opacity: 1;
        -webkit-transform: scale(1.2);
                transform: scale(1.2)
    }
    100% {
        opacity: 1;
        -webkit-transform: scale(0.8);
                transform: scale(0.8)
    }
  }

  /*展览介绍样式*/
  .museum-cover{
    position: absolute;
    left: 50%;
    top: 50%;
    width: rem(1140);
    height: rem(778);
    margin-left: rem(-570);
    margin-top: rem(-389);
    background:url('../assets/img/pc/bgNew.jpg');
    background-size: cover;

    background-size: 100% 100%;
    font-size: 0;
    border-radius: rem(5);
    overflow: hidden;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .area{
      position: absolute;
      left: 0;
      top: 0;
      right: rem(30);
      bottom: 0;
    }
    .box{
      width: rem(600);
      height: auto;
      margin-left: rem(300);
      margin-bottom: rem(50);
      text-align: center;
    }
    .logo{
      display: inline-block;
      width: rem(600);
      height: rem(130);
      background: url("../assets/img/pc/text-logo.png") no-repeat 0 0;
      background-size: cover;
      margin-top: rem(140);
      margin-bottom: rem(30);
    }
    .intro{
      width: 100%;
      li{
        margin-bottom: rem(30);
        padding: 0 rem(20);
      }
      h3{
        font-family: SemiBold;
        font-size: rem(26);
        color: #FCDCA4;
        letter-spacing: rem(1);
        text-align: center;
        line-height: rem(40);
      }
      h4{
        font-family: SemiBold;
        font-size: rem(20);
        color: #FCDCA4;
        letter-spacing: rem(1);
        text-align: center;
        line-height: rem(35);
        text-indent: 2em;
      }
    }
    .official-web-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      left: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-official-web.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .contact-us-btn{
      width: rem(159);
      height: rem(34);
      position: absolute;
      right: rem(28);
      top: rem(477);
      background: url("../assets/img/mobile/btn-contact-us.png") no-repeat 0 0;
      background-size: rem(159) rem(34);
    }
    .close-btn{
      width: rem(26);
      height: rem(26);
      background: url("../assets/img/pc/icon-close-white.png") no-repeat 0 0;
      background-size: rem(26) rem(26);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      z-index: 1;
    }
    .swiper-scrollbar-drag{
      background: #FCD187;
    }
  }

  // 图文marker marker介绍非皓月id的类型展示蒙层
  .markerInfoFull-cover {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background:url('../assets/img/pc/bgNew.jpg');
    background-size: cover;
    background-size: 100% 100%;
    font-size: 0;
    border-radius: rem(5);
    overflow: scroll;
    padding: rem(30);
    box-sizing: border-box;
    .intro{
      width: 90%;
      margin: auto;
      text-align: left;
      h3{
        font-family: SemiBold;
        font-size: rem(26);
        color: #FCDCA4;
        letter-spacing: rem(1);
        text-align: center;
        line-height: rem(40);
        margin: rem(30);
      }
      div.textHtml{
        font-family: SemiBold;
        font-size: rem(20);
        color: #FCDCA4;
        letter-spacing: rem(1);
        text-align: left;
        line-height: rem(35);
      }
      img {
        width: rem(500);
        text-align: center;
      }
    }
    .close-btn{
      width: rem(50);
      height: rem(50);
      background: url("../assets/img/pc/icon-close-white.png") no-repeat 0 0;
      background-size: rem(50) rem(50);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      z-index: 1;
    }
  }
  .honor-box{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(4, 20, 32, 0.6);
    background-size: cover;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .title{
      width: rem(215);
      height: rem(19);
      position: absolute;
      left: 50%;
      top: rem(34);
      transform: translateX(-50%);
      background: url("../assets/img/mobile/title-honor-wall.png") no-repeat 0 0;
      background-size: rem(215) rem(19);
    }
    .close-btn{
      width: rem(47);
      height: rem(47);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
    .honor-wall{
      position: absolute;
      top: rem(80);
      left: 0;
      right: 0;
      bottom: 0;
      display: -webkit-box;
      overflow-y: auto;
      ul{
        box-sizing: border-box;
        width: 100%;
        padding-left: rem(20);
      }
      li{
        float: left;
        width: rem(105);
        height: rem(105);
        font-size: 0;
        margin-right: rem(10);
        margin-bottom: rem(10);
        img{
          width: rem(105);
          height: rem(105);
        }
      }
    }
  }
  .comment-input-cover{
    position: absolute;
    top: 0;
    right: rem(-360);
    /*background: linear-gradient(to bottom, rgba(239,97,69,0.95) 0%, rgba(173,13,13,0.95) 64%, rgba(157,2,2,0.95) 100%);;*/
    z-index: 20;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .close-btn{
      width: rem(47);
      height: rem(47);
      background: url("../assets/img/mobile/icon-close.png") no-repeat 0 0;
      background-size: rem(47) rem(47);
      position: absolute;
      right: rem(50);
      top: rem(50);
      cursor: pointer;
    }
    .comment-input-box{
      input{
        width: rem(246);
        padding: 0 rem(14);
        margin-top: rem(4);
        margin-right: rem(10);
        height: rem(30);
        font-size: rem(13);
        line-height: rem(30);
        color: #ffffff;
        background: rgba(91,18,3);
        border: 1px solid #FCD187;
        border-radius: rem(15);
        opacity: 0.5;
        &::-webkit-input-placeholder{
          color: #ffffff;
          font-size: rem(13);
        }
      }
      .comment-btn{
        margin-top: rem(4);
        width: rem(69);
        height: rem(32);
        background-image: linear-gradient(-180deg, #E7C68C 0%, #DEB572 49%, #BC852F 100%);
        border-radius: rem(16);
        font-size: rem(14);
        line-height: rem(32);
        color: #ffffff;
        letter-spacing: rem(1);
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .share-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(21,0,0,0.8);
    z-index: 20;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    img{
      width: rem(182);
      height: rem(169);
      position: absolute;
      right: rem(34);
      top: rem(5);
    }
    p{
      width: 100%;
      height: rem(18);
      font-family: PingFangSC-Regular;
      font-size: rem(13);
      line-height: rem(18);
      color: #FFFFFF;
      letter-spacing: rem(1);
      text-align: center;
      position: absolute;
      left: 0;
      top: rem(203);
    }
  }
  .full-map-cover{
    position: absolute;
    left: rem(50);
    top: rem(120);
    width: rem(490);
    height: rem(569);
    background: rgba(4, 20, 32, 0.6);
    background-size: 100% 100%;
    border-radius: rem(5);
    overflow: hidden;
    opacity: 1;
    &.cover-enter, &.cover-leave-to {
      opacity: 0;
    }
    &.cover-enter-active, &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .bottom-tip{
      width: rem(440);
      height: rem(138);
      background: url("../assets/img/mobile/map-bottom-tip.png") no-repeat 0 0;
      background-size: rem(440) rem(138);
      position: absolute;
      left: 50%;
      bottom: rem(30);
      margin-left: rem(-220);
    }
    .map{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -60%, 0);
      width: rem(440);
      height: rem(710);
      background-image: url("../assets/img/mobile/map-total.png");
      background-size: rem(440) rem(710);
      .radar-box{
        position: absolute;
        left: 0;
        top: 0;
      }
      .radar {
        width: rem(32);
        height: rem(27);
        position: absolute;
        left: rem(-15);
        top: rem(-28);
        transform: rotateZ(0);
        transform-origin: center bottom;
        &::after{
          content: ' ';
          display: block;
          width: rem(32);
          height: rem(27);
          position: absolute;
          left: 0;
          top: 0;
          background: url("../assets/img/mobile/map-radar-big.png") no-repeat 0 0;
          background-size: rem(32) rem(27);
        }
      }
      .circle{
        width: rem(14);
        height: rem(14);
        position: absolute;
        left: rem(-7);
        top: rem(-7);
        background: url("../assets/img/mobile/map-circle-big.png") no-repeat 0 0;
        background-size: rem(14) rem(14);
        z-index: 2;
      }
      .wenwu-box{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .wenwu-mk{
          width: rem(25);
          height: rem(25);
          font-size: 0;
          position: absolute;
          transform: translate3d(rem(-13), rem(-25), 0);
          img{
            width: rem(18);
            height: rem(25);
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: rem(-9);
            margin-top: rem(-12);
            cursor: pointer;
            transition: transform 0.3s;
            transform-origin: center center;
            &:hover{
              transform: scale3d(1.5, 1.5, 1);
            }
          }
        }
        .circle-mk{
          width: rem(14);
          height: rem(14);
          font-size: 0;
          position: absolute;
          transform: translate3d(rem(-7), rem(-7), 0);
          .hover-cover{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: url("../assets/img/mobile/map-circle-big.png") no-repeat 0 0;
            background-size: rem(14) rem(14);
            cursor: pointer;
            transition: transform 0.3s;
            transform-origin: center center;
            &:hover{
              transform: scale3d(1.5, 1.5, 1);
            }
            &.is-view{
              background: url("../assets/img/pc/map-circle-isview.png") no-repeat 0 0;
              background-size: rem(14) rem(14);
            }
          }
        }
      }
    }
    .close-btn{
      display: block;
      width: rem(25);
      height: rem(25);
      background: url("../assets/img/pc/icon-close.png") no-repeat 0 0;
      background-size: rem(25) rem(25);
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }
  .roaming-cover{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .intro-audio-box{
    width: rem(356);
    height: rem(44);
    position: absolute;
    left: rem(40);
    bottom: rem(40);
    background: #385492;
    border-radius: rem(22);
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::after{
      content: ' ';
      width: rem(56);
      height: rem(24);
      background: url("../assets/img/pc/icon-dizhen-jump.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: absolute;
      right: rem(42);
      top: rem(-10);
    }
    span{
      display: block;
      width: rem(44);
      height: rem(44);
      box-sizing: border-box;
      border: 1px solid #ffffff;
      border-radius: 50%;

      margin-right: rem(8);
      text-align: center;
      & i{
        width:rem(34);
        height: rem(34);
        display: block;
        border-radius: 50%;
        /*background:  url("../assets/img/pc/audio-robert.png") no-repeat center center;*/
        background:  url("../assets/img/pc/AI.gif") no-repeat center center;
        background-size: rem(34) rem(34);
        margin: auto;
        line-height: rem(44);
        margin-top: rem(4);
      }
    }
    .play-btn{
      width: rem(24);
      height: rem(24);
      background: url("../assets/img/pc/icon-audio-play.png") no-repeat 0 0;
      background-size: 100% 100%;
      margin-right: rem(14);
      cursor: pointer;
      &.pause{
        background: url("../assets/img/pc/icon-audio-pause.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
    .time{
      font-size: rem(12);
      font-weight: 500;
      color: #FFFFFF;
      line-height: rem(12);
      text-shadow: 0px 2px 4px rgba(10, 21, 50, 0.45);
    }
    .progress-box{
      width: rem(164);
      height: rem(3);
      background: rgba(10,21,50,0.45);
      margin-right: rem(22);
      .progress{
        width: 40%;
        height: rem(3);
        background: #ffffff;
      }
    }
  }

  @keyframes mapHover
  {
    0% {
      transform: scale3d(1,1,1);
      opacity: 1;
    }
    20% {
      transform: scale3d(1.2,1.2,1);
      opacity: 0;
    }
    30% {
      transform: scale3d(0.8,0.8,1);
      opacity: 0;
    }
    60% {
      transform: scale3d(1,1,1);
      opacity: 1;
    }
  }

  @keyframes musicRotate
  {
    0% {
      transform: rotateZ(-60deg);
    }
    100% {
      transform: rotateZ(300deg);
    }
  }

  @keyframes audioPlaying {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(rem(-90));
    }
  }

  @keyframes twinkle {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }

  /*test */
  @keyframes markerBtnJumptest {
  0% {
  transform: translate3d(rem(-26), rem(-54), 0);
  }
  50% {
        transform: translate3d(rem(-26), rem(-60), 0);
        }
  100% {
         transform: translate3d(rem(-26), rem(-54), 0);
         }
  }

  @keyframes markerBtnJump1test {
    0% {
      transform: translate3d(rem(-26*1.5), rem(-54*1.5), 0);
    }
    50% {
      transform: translate3d(rem(-26*1.5), rem(-54*1.5 - 6), 0);
    }
    100% {
      transform: translate3d(rem(-26*1.5), rem(-54*1.5), 0);
    }
  }
  /*test */


  @keyframes markerBtnJump {

    0% {
      transform: translate3d(rem(-21), rem(-33), 0);
    }
    50% {
      transform: translate3d(rem(-21), rem(-43), 0);
    }
    100% {
      transform: translate3d(rem(-21), rem(-33), 0);
    }
  }

  @keyframes markerBtnJump1 {
    0% {
      transform: translate3d(rem(-21*1.1), rem(-33*1.1), 0);
    }
    50% {
      transform: translate3d(rem(-21*1.1), rem(-33*1.1 - 6), 0);
    }
    100% {
      transform: translate3d(rem(-21*1.1), rem(-33*1.1), 0);
    }
  }

  .loading-box{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    // background-color: rgba(2, 2, 2, 1);
    background-image: url("../assets/img/pc/twoBtns.png");
    background-size: 100% 100%;
    .twoCircles {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        cursor: pointer;
        width: 220px;
        height: 220px;
        line-height: 220px;
        text-align: center;
        font-size:35px;
        transition: transform .5s;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,203,122,1);
        letter-spacing:3px;
        background-image: url("../assets/img/pc/circle.png");
        background-size: 220px 220px;
        &:first-child {
          margin-right: 292px;
        }
        &:hover {
          transform: scale(1.1,1.1);
        }
      }
    }
    // .loading-icon-back{
    //   width: rem(100);
    //   height: rem(100);
    //   background: url("../assets/img/mobile/loading-back.png") no-repeat center center;
    //   background-size: rem(100) rem(100);
    //   position: absolute;
    //   left: 50%;
    //   top: 50%;
    //   margin-left: rem(-50);
    //   margin-top: rem(-50);

    //   .loading-icon{
    //     width: rem(50);
    //     height: rem(50);
    //     background: url("../assets/img/mobile/loading.png") no-repeat center center;
    //     background-size: rem(50) rem(50);
    //     position: absolute;
    //     left: 50%;
    //     top: 50%;
    //     margin-left: rem(-25);
    //     margin-top: rem(-25);
    //     -webkit-animation: loadingmove 1s forwards steps(10) infinite;
    //     animation: loadingmove 1s forwards steps(10) infinite;
    //   }

    //   @-webkit-keyframes loadingmove {
    //     0% { -webkit-transform: rotateZ(0); }
    //     100% { -webkit-transform: rotateZ(360deg); }
    //   }

    //   @keyframes loadingmove {
    //     0% { transform: rotateZ(0); }
    //     100% { transform: rotateZ(360deg); }
    //   }
    // }
  }

  .imitatediv{
    width: 100%;
    /*height: 1000px;*/
  }

</style>
